/* Vesari theme behaviour. Vanilla, no framework. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- first-visit intro (home only, once per session, never under reduced motion) ---------- */
  const introCurtain = $('[data-intro]');
  if (introCurtain) {
    let play = false;
    try {
      if (!sessionStorage.getItem('vesari:intro') && !reduced) {
        sessionStorage.setItem('vesari:intro', '1');
        play = true;
      }
    } catch {}
    if (!play) introCurtain.remove();
    else {
      const prevOverflow = document.body.style.overflow;
      introCurtain.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(() => {
        $('[data-intro-top]', introCurtain).classList.add('-translate-y-full');
        $('[data-intro-bottom]', introCurtain).classList.add('translate-y-full');
        const mark = $('[data-intro-mark]', introCurtain);
        mark.classList.remove('animate-rise', 'opacity-100');
        mark.classList.add('opacity-0');
      }, 650);
      setTimeout(() => {
        introCurtain.remove();
        document.body.style.overflow = prevOverflow;
      }, 1300);
    }
  }

  const money = (cents) => {
    const f = (window.Vesari?.money_format || '${{amount}}');
    const amount = (cents / 100).toLocaleString('en-CA', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
    return f.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  /* ---------- reveal on scroll ---------- */
  const revealer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => entries.forEach((e) => e.isIntersecting && (e.target.classList.add('is-in'), revealer.unobserve(e.target))),
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
        )
      : null;
  $$('.reveal').forEach((el) => (revealer ? revealer.observe(el) : el.classList.add('is-in')));

  /* ---------- announcement: the old message fades right out, then the new one fades in ---------- */
  // As the site's AnnouncementBar: the two never show on top of each other.
  const items = $$('[data-announcement-item]');
  if (items.length > 1 && !reduced) {
    let i = 0;
    setInterval(() => {
      i = (i + 1) % items.length;
      items.forEach((el, idx) => {
        const on = idx === i;
        el.classList.toggle('opacity-100', on);
        el.classList.toggle('delay-[350ms]', on);
        el.classList.toggle('duration-[600ms]', on);
        el.classList.toggle('opacity-0', !on);
        el.classList.toggle('duration-[350ms]', !on);
        el.classList.toggle('pointer-events-none', !on);
        el.tabIndex = on ? 0 : -1;
        el.setAttribute('aria-hidden', String(!on));
      });
    }, 7000);
  }

  /* ---------- home video: phones play their own portrait film ---------- */
  // As the site's HomeVideo: the source is chosen on the device (below 768px the phone film), never both downloaded.
  // The poster shows at once; the film loads only as the band comes within 600px of the screen, and pauses while away.
  // Visitors who have asked their device for reduced motion get the still poster only.
  $$('[data-home-video]').forEach((v) => {
    const phone = matchMedia('(max-width: 767px)');
    let near = false;
    const pick = () => {
      v.poster = phone.matches ? v.dataset.phonePoster : v.dataset.poster;
      if (!near || reduced) return;
      const next = phone.matches ? v.dataset.phoneSrc : v.dataset.src;
      if (v.getAttribute('src') !== next) v.src = next;
      v.play().catch(() => {});
    };
    const io = new IntersectionObserver(
      ([e]) => {
        near = e.isIntersecting;
        if (near) pick();
        else v.pause();
      },
      { rootMargin: '600px 0px' },
    );
    pick();
    io.observe(v);
    phone.addEventListener('change', pick);
  });

  /* ---------- gift card stage: tilts towards a mouse and catches a soft light (the site's GiftCardStage) ---------- */
  $$('[data-gift-stage]').forEach((stage) => {
    const card = $('[data-gift-card]', stage);
    if (!card) return;
    stage.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse' || reduced) return;
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      card.style.setProperty('--rx', `${(-y * 8).toFixed(2)}deg`);
      card.style.setProperty('--ry', `${(x * 10).toFixed(2)}deg`);
      card.style.setProperty('--lx', `${((x + 0.5) * 100).toFixed(1)}%`);
      card.style.setProperty('--ly', `${((y + 0.5) * 100).toFixed(1)}%`);
      card.dataset.lit = '';
    });
    stage.addEventListener('pointerleave', () => {
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
      delete card.dataset.lit;
    });
  });

  /* ---------- background films (Our Story): play on their own, except under reduced motion (the site's MotionVideo) ---------- */
  // The markup leaves `autoplay` off on purpose, so nothing moves before the preference has been read.
  $$('[data-motion-video]').forEach((v) => {
    if (!reduced) v.play().catch(() => {});
  });

  /* ---------- header: transparent over the hero ---------- */
  const header = $('[data-header]');
  // A hovered nav link, open search or open phone menu holds the header solid; syncHeader re-applies the state.
  let headerHeldSolid = false;
  let menuIsOpen = false;
  let searchIsOpen = false;
  let syncHeader = () => {};
  // Cross-links between the header blocks below (menu and search close each other; search gates the nav panel).
  let setSearchOpen = () => {};
  let closeMenu = () => {};
  let syncNavPanel = () => {};
  if (header?.hasAttribute('data-header-transparent')) {
    const bar = $('[data-header-bar]', header);
    const logo = $('[data-logo]', header);
    const onScroll = () => {
      const solid = headerHeldSolid || menuIsOpen || searchIsOpen || window.scrollY > 24;
      header.classList.toggle('text-paper', !solid);
      header.classList.toggle('text-ink', solid);
      bar.classList.toggle('bg-page', solid);
      bar.classList.toggle('bg-transparent', !solid);
      const count = $('[data-cart-count]', header);
      count?.classList.toggle('text-ink', !solid);
      count?.classList.toggle('text-paper', solid);
      if (logo) {
        const want = solid ? logo.dataset.logoDark : logo.dataset.logoLight;
        if (want && logo.getAttribute('src') !== want) logo.setAttribute('src', want);
      }
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    syncHeader = onScroll;
  }

  /* ---------- header: collection panel on hover (desktop) ---------- */
  const navLinks = $$('[data-nav-link]');
  const navPanel = header && $('[data-nav-panel]', header);
  if (header && navPanel && navLinks.length) {
    let timer = 0;
    let current = null;
    const later = (fn, ms) => { clearTimeout(timer); timer = setTimeout(fn, ms); };
    // One panel: the hovered collection's content is swapped in at once; closing empties it and only the box fades.
    // It stays hidden while search is open, but the hovered link still holds the header solid.
    const render = () => {
      const show = Boolean(current) && !searchIsOpen;
      navPanel.classList.toggle('translate-y-0', show);
      navPanel.classList.toggle('opacity-100', show);
      navPanel.classList.toggle('pointer-events-none', !show);
      navPanel.classList.toggle('-translate-y-1', !show);
      navPanel.classList.toggle('opacity-0', !show);
      navPanel.setAttribute('aria-hidden', String(!show));
      $$('[data-nav-panel-content]', navPanel).forEach((c) => c.classList.toggle('hidden', c.dataset.navPanelContent !== current));
    };
    const setOpen = (handle) => {
      if (handle === current) return;
      current = handle;
      render();
      navLinks.forEach((a) => {
        const on = a.dataset.navLink === handle;
        a.setAttribute('aria-expanded', String(on));
        a.classList.toggle('[&::after]:scale-x-100', on);
      });
      headerHeldSolid = Boolean(handle);
      syncHeader();
    };
    syncNavPanel = render;
    navLinks.forEach((a) => {
      a.addEventListener('pointerenter', () => later(() => setOpen(a.dataset.navLink), 90));
      a.addEventListener('focus', () => later(() => setOpen(a.dataset.navLink), 90));
      a.addEventListener('click', () => setOpen(null));
    });
    // A nav link with no collection behind it closes whatever is open (by pointer or by keyboard focus).
    $$('nav[aria-label="Primary"] a:not([data-nav-link])', header).forEach((a) => {
      a.addEventListener('pointerenter', () => later(() => setOpen(null), 90));
      a.addEventListener('focus', () => later(() => setOpen(null), 90));
      a.addEventListener('click', () => setOpen(null));
    });
    $('[data-header-bar]', header)?.addEventListener('pointerleave', () => later(() => setOpen(null), 160));
    $('[data-nav-panel-wrap]', header)?.addEventListener('pointerenter', () => clearTimeout(timer));
    navPanel.addEventListener('click', (e) => e.target.closest('a') && setOpen(null));
    addEventListener('keydown', (e) => e.key === 'Escape' && setOpen(null));
  }

  /* ---------- hero parallax ---------- */
  const media = $('[data-parallax-media]');
  if (media && !reduced) {
    let raf = 0;
    const tick = () => {
      raf = 0;
      const y = Math.min(scrollY, innerHeight);
      media.style.transform = `translate3d(0, ${y * 0.3}px, 0)`;
    };
    tick();
    addEventListener('scroll', () => raf || (raf = requestAnimationFrame(tick)), { passive: true });
  }

  /* ---------- panels: menu, search, cart, size guide ---------- */
  // Keyboard care for an overlay (the bag, the size guide, the photo viewer), as the site's use-modal-focus.ts: when it
  // opens, focus moves to its first control; Tab and Shift+Tab stay inside it; when it closes (the returned release),
  // focus goes back to whatever opened it.
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const holdFocus = (el) => {
    const opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const items = () => $$(FOCUSABLE, el).filter((n) => n.getClientRects().length > 0 && !n.closest('[inert]'));
    const t = setTimeout(() => {
      if (!el.contains(document.activeElement)) (items()[0] ?? el).focus({ preventScroll: true });
    }, 60);
    const onKey = (e) => {
      if (e.key !== 'Tab') return;
      const list = items();
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];
      const inside = el.contains(document.activeElement);
      if (e.shiftKey && (!inside || document.activeElement === first)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (!inside || document.activeElement === last)) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => {
      clearTimeout(t);
      document.removeEventListener('keydown', onKey);
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    };
  };

  // Bag and size guide: closed, the root is inert; open, focus is held in the panel (released on close).
  const held = new WeakMap();
  function openPanel(root, { panel, scrim, onOpen } = {}) {
    root.setAttribute('aria-hidden', 'false');
    root.removeAttribute('inert');
    root.classList.remove('pointer-events-none');
    requestAnimationFrame(() => {
      scrim && (scrim.style.opacity = '1');
      panel && panel.classList.remove('translate-x-full', '-translate-x-full', 'translate-y-full', 'opacity-0', '-translate-y-2');
      onOpen?.();
    });
    if (!held.has(root)) held.set(root, holdFocus(panel || root));
    document.body.style.overflow = 'hidden';
  }
  function closePanel(root, { panel, scrim, classes = ['translate-x-full'] } = {}) {
    scrim && (scrim.style.opacity = '0');
    panel && panel.classList.add(...classes);
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('inert', '');
    root.classList.add('pointer-events-none');
    document.body.style.overflow = '';
    held.get(root)?.();
    held.delete(root);
  }

  // Mobile menu
  const menu = $('[data-mobile-menu]');
  if (menu) {
    const panel = $('[data-menu-panel]', menu);
    const scrim = $('[data-menu-close]', menu);
    const toggle = $('[data-menu-toggle]');
    const top = $('[data-bar-top]');
    const bottom = $('[data-bar-bottom]');
    let prevOverflow = '';
    let opener = null;
    let focusTimer = 0;
    const setMenuOpen = (open) => {
      if (open === menuIsOpen) return;
      menuIsOpen = open;
      // Keyboard: focus goes to the first link as the menu opens, and back to the menu button as it closes (when it was
      // left in the menu or nowhere).
      const active = document.activeElement;
      const back = !open && (!active || active === document.body || menu.contains(active));
      if (open) opener = active instanceof HTMLElement ? active : null;
      menu.setAttribute('aria-hidden', String(!open));
      menu.toggleAttribute('inert', !open);
      menu.classList.toggle('pointer-events-none', !open);
      scrim?.classList.toggle('opacity-100', open);
      scrim?.classList.toggle('opacity-0', !open);
      panel?.classList.toggle('translate-x-0', open);
      panel?.classList.toggle('-translate-x-full', !open);
      top?.classList.toggle('translate-y-[4.5px]', open);
      top?.classList.toggle('rotate-45', open);
      bottom?.classList.toggle('-translate-y-[4.5px]', open);
      bottom?.classList.toggle('-rotate-45', open);
      toggle?.setAttribute('aria-expanded', String(open));
      toggle?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (open) {
        prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      } else document.body.style.overflow = prevOverflow;
      clearTimeout(focusTimer);
      if (open) focusTimer = setTimeout(() => panel?.querySelector('a[href]')?.focus({ preventScroll: true }), 60);
      else if (back && opener?.isConnected) opener.focus({ preventScroll: true });
      syncHeader();
      // Tells the Join the list pill to step aside while the menu is open.
      dispatchEvent(new CustomEvent('vesari:menu', { detail: open }));
    };
    closeMenu = () => setMenuOpen(false);
    // Search closes first, so its scroll lock is given back before the menu takes its own.
    toggle?.addEventListener('click', () => {
      setSearchOpen(false);
      setMenuOpen(!menuIsOpen);
    });
    scrim?.addEventListener('click', closeMenu);
    $$('[data-menu-link]', menu).forEach((a) => a.addEventListener('click', closeMenu));
    addEventListener('keydown', (e) => e.key === 'Escape' && menuIsOpen && closeMenu());
  }

  // Search
  const searchPanel = $('[data-search-panel]');
  if (searchPanel) {
    const scrim = $('[data-search-scrim]');
    const form = $('[data-search-form]', searchPanel);
    const input = $('[data-search-input]', searchPanel);
    const rule = $('[data-search-rule]', searchPanel);
    const arrow = $('[data-search-arrow]', searchPanel);
    const results = $('[data-search-results]', searchPanel);
    const count = $('[data-search-count]', searchPanel);
    const suggestions = $('[data-search-suggestions]', searchPanel);
    const links = $$('[data-search-suggestion]', searchPanel);
    const toggle = $('[data-search-toggle]');
    const iconSearch = toggle && $('[data-search-icon]', toggle);
    const iconClose = toggle && $('[data-search-icon-close]', toggle);
    let focusTimer = 0;
    let opener = null;
    let prevOverflow = '';
    const setOpen = (next) => {
      if (next === searchIsOpen) return;
      searchIsOpen = next;
      // Focus goes back to whatever opened search (the header's search button) when it closes, if it was left in the
      // panel or nowhere.
      const active = document.activeElement;
      const back = !next && Boolean(active) && (active === document.body || searchPanel.contains(active));
      if (next) opener = active instanceof HTMLElement ? active : null;
      // Closed, nothing inside can be tabbed to or read out.
      searchPanel.toggleAttribute('inert', !next);
      searchPanel.classList.toggle('translate-y-0', next);
      searchPanel.classList.toggle('opacity-100', next);
      searchPanel.classList.toggle('pointer-events-none', !next);
      searchPanel.classList.toggle('-translate-y-2', !next);
      searchPanel.classList.toggle('opacity-0', !next);
      scrim?.classList.toggle('opacity-100', next);
      scrim?.classList.toggle('pointer-events-none', !next);
      scrim?.classList.toggle('opacity-0', !next);
      rule?.classList.toggle('scale-x-0', !next);
      rule?.classList.toggle('scale-x-100', next);
      // Suggestions rise in one after another as the panel opens, and drop back at once as it closes.
      links.forEach((a, i) => {
        a.style.transitionDelay = next ? `${200 + i * 50}ms` : '0ms';
        a.classList.toggle('translate-y-0', next);
        a.classList.toggle('opacity-100', next);
        a.classList.toggle('translate-y-1', !next);
        a.classList.toggle('opacity-0', !next);
      });
      toggle?.setAttribute('aria-expanded', String(next));
      toggle?.setAttribute('aria-label', next ? 'Close search' : 'Search');
      iconSearch?.classList.toggle('contents', !next);
      iconSearch?.classList.toggle('hidden', next);
      iconClose?.classList.toggle('contents', next);
      iconClose?.classList.toggle('hidden', !next);
      clearTimeout(focusTimer);
      if (next) focusTimer = setTimeout(() => input?.focus(), 120);
      // The page under the scrim stays put while search is open, as under the menu and the bag.
      if (next) {
        prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      } else document.body.style.overflow = prevOverflow;
      if (back) opener?.focus({ preventScroll: true });
      syncNavPanel();
      syncHeader();
      // Tells the Join the list pill to step aside while search is open.
      dispatchEvent(new CustomEvent('vesari:search', { detail: next }));
    };
    setSearchOpen = setOpen;
    // The menu closes first, so its scroll lock is given back before search takes its own.
    toggle?.addEventListener('click', () => {
      closeMenu();
      setOpen(!searchIsOpen);
    });
    scrim?.addEventListener('click', () => setOpen(false));
    searchPanel.addEventListener('click', (e) => e.target.closest('a') && setOpen(false));
    addEventListener('keydown', (e) => e.key === 'Escape' && searchIsOpen && setOpen(false));

    // Results follow every keystroke: the suggestions give way at once, older requests are cancelled, and a
    // response is only shown while the field still reads what it was asked for. The count line stays in place.
    let ctrl = null;
    let shown = '';
    const setRows = (nodes) => {
      while (count.nextSibling) count.nextSibling.remove();
      if (nodes.length) count.after(...nodes);
    };
    input?.addEventListener('input', () => {
      const q = input.value.trim();
      ctrl?.abort();
      arrow?.classList.toggle('translate-x-0', Boolean(q));
      arrow?.classList.toggle('-translate-x-1', !q);
      arrow?.classList.toggle('opacity-40', !q);
      results.classList.toggle('hidden', !q);
      suggestions.classList.toggle('hidden', Boolean(q));
      if (!q) {
        shown = '';
        count.textContent = '';
        setRows([]);
        return;
      }
      const c = (ctrl = new AbortController());
      const url = `${window.Vesari.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&section_id=predictive-search`;
      fetch(url, { signal: c.signal })
        .then((res) => {
          if (!res.ok) throw new Error(String(res.status));
          return res.text();
        })
        .then((html) => {
          if (c.signal.aborted || input.value.trim() !== q) return;
          const list = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-list]');
          const n = Number(list?.dataset.count || 0);
          count.textContent = n === 0 ? 'No pieces found' : `${n} ${n === 1 ? 'piece' : 'pieces'}`;
          setRows(list ? [...list.children] : []);
          shown = q;
        })
        .catch(() => {});
    });

    // Submit: exactly one match opens that piece, any other term opens the search page, an empty field Shop All.
    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      const q = input.value.trim();
      const rows = shown && shown === q ? $$('li a', results) : [];
      const searchUrl = window.Vesari?.routes?.search || form.getAttribute('action');
      location.href = rows.length === 1 ? rows[0].href : q ? `${searchUrl}?q=${encodeURIComponent(q)}` : form.dataset.allUrl || '/collections/all';
      setOpen(false);
    });
  }

  // Size guide
  const guide = $('[data-size-guide-drawer]');
  if (guide) {
    const panel = $('[data-size-guide-panel]', guide);
    const scrim = $('[data-size-guide-close]', guide);
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-size-guide]')) openPanel(guide, { panel, scrim });
      if (e.target.closest('[data-size-guide-close]')) closePanel(guide, { panel, scrim });
    });
    // Escape closes it only while it is open (as the site), so it never resets the page scroll lock
    // another overlay holds.
    addEventListener('keydown', (e) => e.key === 'Escape' && guide.getAttribute('aria-hidden') === 'false' && closePanel(guide, { panel, scrim }));
  }

  // Size chart units: cm by default; "in" converts Bust, Lower bust, Waist and Hip (the [data-cm] cells) to one decimal.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-unit]');
    const root = btn?.closest('[data-size-chart]');
    if (!root) return;
    const unit = btn.dataset.unit;
    // The white pill follows aria-pressed (aria-pressed:bg-paper in the markup).
    $$('[data-unit]', root).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    $$('[data-cm]', root).forEach((cell) => {
      cell.textContent = unit === 'in' ? cell.dataset.cm.replace(/\d+(?:\.\d+)?/g, (n) => (Number(n) / 2.54).toFixed(1)) : cell.dataset.cm;
    });
  });

  /* ---------- cart ---------- */
  // Mirrors the site's CartProvider + CartDrawer + /bag. Every change asks Shopify for the re-rendered
  // drawer (and /cart) in the same request (section rendering), then swaps only the contents of the
  // drawer's panel and the /cart root: an open drawer stays open, the list keeps its scroll position,
  // a focused control keeps focus, and only prices that newly appear fade up (price-in), as on the site.
  // Contract for other blocks: addToCart(id, qty = 1) resolves true/false (and opens the drawer),
  // refreshCart() re-renders from the server, openCart() opens; also exposed as window.Vesari.cart.
  const drawer = $('[data-cart-drawer]');
  const mainCart = $('[data-main-cart]');
  const cartParts = () => ({ panel: $('[data-cart-panel]', drawer), scrim: $('[data-cart-close]', drawer) });
  const cartIsOpen = () => drawer?.getAttribute('aria-hidden') === 'false';
  // Opening an open drawer does nothing (the site's setOpen(true)); it never slides in again.
  const openCart = () => drawer && !cartIsOpen() && openPanel(drawer, cartParts());
  const closeCart = () => drawer && closePanel(drawer, cartParts());
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', () => openCart()));
  document.addEventListener('click', (e) => e.target.closest('[data-cart-close]') && closeCart());
  addEventListener('keydown', (e) => e.key === 'Escape' && cartIsOpen() && closeCart());
  const cartSections = () => ['cart-drawer', mainCart?.dataset.sectionId].filter(Boolean).join(',');

  // Prices that stay mounted on the site do not replay price-in when the markup is swapped.
  const still = (root) => root && $$('[class*="animate-[price-in"]', root).forEach((el) => (el.style.animation = 'none'));

  // Free-shipping bar (snippets/free-shipping-bar.liquid), as the site's FreeShippingBar. The goal is
  // the store-currency threshold, converted with Shopify's rate in another presentment currency.
  const readShip = (ship) => {
    if (!ship) return null;
    const sub = Number(ship.dataset.subtotal) || 0;
    const goal = ship.dataset.goal
      ? Number(ship.dataset.goal)
      : Math.round(Number(window.Vesari?.free_shipping_threshold ?? 150) * 100 * Number(window.Shopify?.currency?.rate || 1));
    const rem = Math.max(0, goal - sub);
    return { goal, rem, done: rem === 0, pct: goal > 0 ? Math.min(100, (sub / goal) * 100) : 100 };
  };
  const SHIP_REMAINING =
    '<span class="num font-medium"><span class="inline-block animate-[price-in_450ms_cubic-bezier(0.22,1,0.36,1)]" data-ship-remaining></span></span><span class="text-ink-2"> away from free shipping</span>';
  const SHIP_DONE = '<span class="display text-[17px] italic">You’ve unlocked free shipping.</span>';
  const SHIP_SHEEN = '<span aria-hidden="true" class="ship-sheen absolute inset-y-0 w-1/3" data-ship-sheen></span>';
  const SHIP_KNOB =
    '<span aria-hidden="true" class="absolute top-1/2 h-[9px] w-[9px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-ink bg-paper transition-[left] duration-[900ms] [transition-timing-function:var(--ease-out-quart)]" style="left: 0%" data-ship-knob></span>';
  // First render (page load, or the first piece in an empty bag): fill and knob grow from 0 after 80ms
  // and nothing counts. A change: they move from the previous width while the remaining amount counts
  // over 700ms (1-(1-k)^4). The sheen plays once when the goal is reached; a knob that reappears below
  // the goal starts at its new place.
  const initShip = (ship, prev) => {
    if (!ship) return;
    const s = readShip(ship);
    const text = $('[data-ship-text]', ship);
    const fill = $('[data-ship-fill]', ship);
    if (!text || !fill) return;
    if (s.done === Boolean($('[data-ship-knob]', ship))) {
      // Another currency: Liquid judged "done" against the unconverted goal.
      text.innerHTML = s.done ? SHIP_DONE : SHIP_REMAINING;
      $('[data-ship-knob]', ship)?.remove();
      $('[data-ship-sheen]', ship)?.remove();
      if (s.done) fill.insertAdjacentHTML('beforeend', SHIP_SHEEN);
      else fill.insertAdjacentHTML('afterend', SHIP_KNOB);
    }
    const goalEl = $('[data-ship-goal]', ship);
    const remEl = $('[data-ship-remaining]', ship);
    const counting = Boolean(prev && remEl && prev.rem !== s.rem);
    if (goalEl && !ship.dataset.goal) goalEl.textContent = money(s.goal);
    if (remEl && (counting || !ship.dataset.goal)) remEl.textContent = money(counting ? prev.rem : s.rem);
    const knob = $('[data-ship-knob]', ship);
    const to = `${s.pct}%`;
    if (!prev) {
      fill.style.width = '0%';
      if (knob) knob.style.left = '0%';
      setTimeout(() => {
        fill.style.width = to;
        if (knob) knob.style.left = to;
      }, 80);
      return;
    }
    still(goalEl && goalEl.parentElement);
    if (remEl && !prev.done) still(remEl.parentElement);
    // Already full before this change: the site's sheen stays parked past the end, so it does not replay.
    if (prev.done) $('[data-ship-sheen]', ship)?.remove();
    fill.style.width = `${prev.pct}%`;
    if (knob) knob.style.left = prev.done ? to : `${prev.pct}%`;
    void fill.offsetWidth;
    requestAnimationFrame(() => {
      fill.style.width = to;
      if (knob) knob.style.left = to;
    });
    if (counting) {
      const a = prev.rem;
      const b = s.rem;
      const start = performance.now();
      const tick = (t) => {
        if (!remEl.isConnected) return;
        const k = Math.min(1, (t - start) / 700);
        const e = 1 - Math.pow(1 - k, 4);
        remEl.textContent = money(Math.ceil(a + (b - a) * e));
        if (k < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  };

  // "Pair it perfectly" (snippets/pair-it-perfectly.liquid), as the site's PairItPerfectly: one piece at
  // a time. Index, direction and each piece's chosen size live here, so they survive the panel swaps; a
  // slide (and its price) animates in only when an arrow or swipe moves it or the piece shown changes,
  // never on a quantity change. An empty bag starts over, as the site's component unmounts.
  // No size is chosen for the shopper: Add without one opens the size list and marks it (pairNudge, the
  // piece's handle) until a size is picked or the slide moves on.
  let pairIdx = 0;
  let pairDir = 1;
  let pairShown = null;
  let pairSizes = {};
  let pairNudge = null;
  let pairBag = null;
  const pairPrice = (item) => {
    const option = $('[data-pair-size]', item)?.selectedOptions[0];
    const price = $('[data-pair-price]', item);
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  };
  const markPair = (select, on) => {
    select.classList.toggle('text-ink', on);
    select.classList.toggle('decoration-ink', on);
    select.classList.toggle('text-ink-2', !on);
    select.classList.toggle('decoration-line-soft', !on);
  };
  const showPair = (animate = false) => {
    const root = drawer && $('[data-pair]', drawer);
    if (!root) {
      pairShown = null;
      if (drawer && !$('[data-key]', drawer)) {
        pairIdx = 0;
        pairDir = 1;
        pairSizes = {};
        pairNudge = null;
      }
      return;
    }
    // When the bag changes, the best match for the new bag comes first again (the snippet ranks by the bag).
    const bag = $$('li[data-variant-id]', drawer).map((li) => li.dataset.variantId).sort().join(',');
    if (pairBag !== null && bag !== pairBag) {
      pairIdx = 0;
      pairDir = 1;
    }
    pairBag = bag;
    const items = $$('[data-pair-item]', root);
    const n = items.length;
    if (!n) return;
    const i = ((pairIdx % n) + n) % n;
    const item = items[i];
    items.forEach((el) => (el.hidden = el !== item));
    const count = $('[data-pair-count]', root);
    if (count) count.textContent = `${i + 1} / ${n}`;
    $$('[data-pair-dot]', root).forEach((dot, k) => {
      dot.classList.toggle('w-6', k === i);
      dot.classList.toggle('bg-ink', k === i);
      dot.classList.toggle('w-3', k !== i);
      dot.classList.toggle('bg-line-soft', k !== i);
    });
    const handle = item.dataset.handle;
    const select = $('[data-pair-size]', item);
    const kept = pairSizes[handle];
    if (select && kept && [...select.options].some((o) => o.value === kept && !o.disabled)) {
      select.value = kept;
      pairPrice(item);
    }
    if (select) markPair(select, pairNudge === handle);
    const price = $('[data-pair-price]', item);
    item.classList.remove('pair-from-right', 'pair-from-left');
    if (animate || handle !== pairShown) {
      void item.offsetWidth;
      item.classList.add(pairDir === 1 ? 'pair-from-right' : 'pair-from-left');
      if (price) {
        price.style.animation = 'none';
        void price.offsetWidth;
        price.style.animation = '';
      }
    } else if (price) price.style.animation = 'none';
    pairShown = handle;
  };
  const goPair = (d) => {
    pairDir = d;
    pairIdx += d;
    pairNudge = null;
    showPair(true);
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-pair-prev]')) goPair(-1);
    else if (e.target.closest('[data-pair-next]')) goPair(1);
  });
  let pairTouch = null;
  document.addEventListener(
    'touchstart',
    (e) => (pairTouch = e.target instanceof Element && e.target.closest('[data-pair-stage]') ? e.touches[0].clientX : null),
    { passive: true },
  );
  document.addEventListener(
    'touchend',
    (e) => {
      if (pairTouch === null) return;
      const dx = e.changedTouches[0].clientX - pairTouch;
      pairTouch = null;
      if (Math.abs(dx) > 40) goPair(dx < 0 ? 1 : -1);
    },
    { passive: true },
  );

  // Swap a cart region for fresh section markup, keeping what the site's React re-render keeps.
  const FOCUS_KEYS = ['data-line-minus', 'data-line-plus', 'data-line-remove', 'data-line-qty', 'data-pair-prev', 'data-pair-next', 'data-pair-size', 'data-pair-add', 'data-cart-close', 'data-checkout'];
  const focusPath = (root) => {
    const el = document.activeElement;
    if (!el || el === root || !root.contains(el)) return null;
    const key = FOCUS_KEYS.find((a) => el.hasAttribute(a));
    if (!key) return null;
    const line = el.closest('[data-key]');
    const slide = el.closest('[data-pair-item]');
    if (line) return `[data-key="${CSS.escape(line.dataset.key)}"] [${key}]`;
    if (slide) return `[data-pair-item][data-handle="${CSS.escape(slide.dataset.handle)}"] [${key}]`;
    return `[${key}]`;
  };
  const swapCart = (root, html, selector) => {
    const next = root && html && new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!next) return;
    const keys = new Set($$('[data-key]', root).map((li) => li.dataset.key));
    const prevShip = readShip($('[data-ship]', root));
    const scroller = $('[data-cart-scroll]', root);
    const top = scroller ? scroller.scrollTop : 0;
    const focus = focusPath(root);
    root.innerHTML = next.innerHTML;
    const scrollerNext = $('[data-cart-scroll]', root);
    if (scrollerNext) scrollerNext.scrollTop = top;
    if (focus) $(focus, root)?.focus({ preventScroll: true });
    $$('[data-key]', root).forEach((li) => keys.has(li.dataset.key) && still(li));
    if (keys.size) $$('[data-cart-totals]', root).forEach(still);
    initShip($('[data-ship]', root), prevShip);
  };
  const setCartCount = (n) => {
    $$('[data-cart-count]').forEach((el) => (el.textContent = n));
    $$('[data-cart-count-wrap]').forEach((el) => el.classList.toggle('hidden', n === 0));
    $$('[data-cart-open]').forEach((el) => el.setAttribute('aria-label', `Open bag, ${n} items`));
  };
  const applyCart = (sections) => {
    if (!sections) return;
    if (drawer && sections['cart-drawer']) {
      swapCart($('[data-cart-panel]', drawer), sections['cart-drawer'], '[data-cart-panel]');
      showPair();
    }
    const id = mainCart?.dataset.sectionId;
    if (id && sections[id]) swapCart(mainCart, sections[id], '[data-main-cart]');
    const count = drawer && $('[data-count]', drawer);
    if (count) setCartCount(Number(count.dataset.count) || 0);
    // The bag has been redrawn: a product page's "Added to bag" checks its piece is still in it.
    dispatchEvent(new CustomEvent('vesari:cart'));
  };

  async function refreshCart(sections) {
    if (!sections) {
      try {
        const res = await fetch(`${location.pathname}?sections=${cartSections()}`);
        sections = await res.json();
      } catch {
        return;
      }
    }
    applyCart(sections);
  }

  // Bag changes run one after another, so fast taps each apply in order (the site dispatches each one
  // at once); the markup is swapped when the last one has landed. A failed change resyncs from Shopify.
  let cartQueue = Promise.resolve();
  let cartPending = 0;
  let cartLatest = null;
  const cartRequest = (route, payload) => {
    cartPending += 1;
    const run = cartQueue.then(async () => {
      try {
        const res = await fetch(`${route}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ ...payload, sections: cartSections(), sections_url: location.pathname }),
        });
        const json = await res.json().catch(() => ({}));
        if (res.ok && json.sections) cartLatest = json.sections;
        return res.ok;
      } catch {
        return false;
      }
    });
    cartQueue = run;
    return run.then(async (ok) => {
      cartPending -= 1;
      if (cartPending === 0) {
        const sections = cartLatest;
        cartLatest = null;
        await refreshCart(sections || undefined);
      }
      return ok;
    });
  };

  // An add merges into its line up to 10, as the site's reducer does; at 10 it only opens the bag.
  // The drawer opens once the new markup is in (never with the old bag sliding in first).
  async function addToCart(id, quantity = 1) {
    const vid = String(id);
    const inBag = drawer
      ? $$('li[data-variant-id]', drawer).filter((li) => li.dataset.variantId === vid).reduce((n, li) => n + (Number(li.dataset.qty) || 0), 0)
      : 0;
    const qty = Math.min(Math.max(1, Number(quantity) || 1), 10 - inBag);
    if (qty <= 0) {
      openCart();
      return true;
    }
    const ok = await cartRequest(window.Vesari.routes.cart_add, { items: [{ id: Number(id), quantity: qty }] });
    openCart();
    return ok;
  }
  window.Vesari = window.Vesari || {};
  window.Vesari.cart = { add: addToCart, refresh: refreshCart, open: openCart };

  // /cart: the Qty select applies at once (the site's setQuantity); a pair size choice is kept per piece.
  document.addEventListener('change', (e) => {
    if (!(e.target instanceof Element)) return;
    const pairSize = e.target.closest('[data-pair-size]');
    if (pairSize) {
      const item = pairSize.closest('[data-pair-item]');
      if (item) {
        pairSizes[item.dataset.handle] = pairSize.value;
        pairPrice(item);
      }
      pairNudge = null;
      markPair(pairSize, false);
      return;
    }
    const qty = e.target.closest('[data-line-qty]');
    const line = qty?.closest('[data-key]');
    if (!line) return;
    line.dataset.qty = qty.value;
    cartRequest(window.Vesari.routes.cart_change, { id: line.dataset.key, quantity: Number(qty.value) });
  });

  // Checkout (snippets/checkout-button.liquid), as the site's CheckoutButton: "Opening checkout" and a
  // progress line while Shopify loads checkout. A page restored from the back/forward cache resets it.
  document.addEventListener('submit', (e) => {
    const button = e.target instanceof Element ? $('[data-checkout]', e.target) : null;
    if (!button || e.defaultPrevented || (e.submitter && e.submitter !== button)) return;
    const label = $('[data-checkout-label]', button);
    if (!label || button.getAttribute('aria-busy') === 'true') return;
    button.dataset.idleLabel = label.innerHTML;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Opening checkout';
    button.insertAdjacentHTML('beforeend', '<span aria-hidden="true" class="checkout-progress absolute bottom-0 left-0 h-[2px] bg-current" data-checkout-progress></span>');
  });
  addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    $$('[data-checkout][aria-busy="true"]').forEach((button) => {
      const label = $('[data-checkout-label]', button);
      if (label && button.dataset.idleLabel) label.innerHTML = button.dataset.idleLabel;
      button.setAttribute('aria-busy', 'false');
      $('[data-checkout-progress]', button)?.remove();
    });
  });

  $$('[data-ship]').forEach((ship) => initShip(ship, null));
  showPair();

  // Tile quick add on touch screens (site QuickAdd): data-open on [data-quick] slides the sizes up and turns the
  // "+" into a close mark; a tap anywhere else puts them away.
  let quickSeq = 0;
  const setQuickOpen = (root, open) => {
    if (!root) return;
    root.toggleAttribute('data-open', open);
    const t = $('[data-quick-toggle]', root);
    const strip = $('[data-quick-add]', root);
    if (strip && !strip.id) strip.id = `quick-add-${++quickSeq}`;
    t?.setAttribute('aria-controls', strip?.id || '');
    t?.setAttribute('aria-expanded', String(open));
    t?.setAttribute('aria-label', open ? t.dataset.labelClose : t.dataset.labelOpen);
  };
  document.addEventListener('pointerdown', (e) => {
    $$('[data-quick][data-open]').forEach((root) => !root.contains(e.target) && setQuickOpen(root, false));
  });

  // Tile colour dots (site ProductTileView): the chosen dot is ringed and its fill shrinks inside the ring; a tile
  // switched away from the colour it opened with eases its lead photo in.
  const TILE_SWAP = 'animate-[tile-swap_450ms_cubic-bezier(0.22,1,0.36,1)]';
  const DOT_ON = ['h-3.5', 'w-3.5'];
  const DOT_OFF = ['h-[18px]', 'w-[18px]'];

  document.addEventListener('click', async (e) => {
    const quickToggle = e.target.closest('[data-quick-toggle]');
    if (quickToggle) {
      e.preventDefault();
      e.stopPropagation();
      const root = quickToggle.closest('[data-quick]');
      setQuickOpen(root, !root.hasAttribute('data-open'));
      return;
    }
    // Tile quick add (site QuickAdd): clicks anywhere on the strip never follow the tile link. The
    // clicked size reads "Added" (underlined) and any other size in the strip reverts; every click
    // clears the strip 1800ms later. The drawer opens once the add has landed, no sooner than 250ms.
    const quickStrip = e.target.closest('[data-quick-add]');
    if (quickStrip) {
      e.preventDefault();
      const quick = e.target.closest('[data-quick-add-variant]');
      if (!quick || quick.disabled) return;
      e.stopPropagation();
      // On touch screens the added size keeps its own label (underlined) instead of "Added", as the site's QuickAdd.
      const showAdded = (b, added) => {
        if (added) {
          const word = document.createElement('span');
          word.className = 'pointer-coarse:hidden';
          word.textContent = window.Vesari.strings.added;
          const size = document.createElement('span');
          size.className = 'hidden pointer-coarse:inline';
          size.textContent = b.dataset.size;
          b.replaceChildren(word, size);
        } else b.textContent = b.dataset.size;
        b.classList.toggle('underline', added);
        b.classList.toggle('underline-offset-4', added);
        b.classList.toggle('hover:underline', !added);
        b.classList.toggle('hover:underline-offset-4', !added);
      };
      const clearAdded = () => $$('[data-quick-add-variant]:not(:disabled)', quickStrip).forEach((b) => showAdded(b, false));
      clearAdded();
      showAdded(quick, true);
      setTimeout(clearAdded, 1800);
      const minDelay = new Promise((r) => setTimeout(r, 250));
      await addToCart(quick.dataset.quickAddVariant);
      await minDelay;
      openCart();
      setQuickOpen(quickStrip.closest('[data-quick]'), false);
      return;
    }
    // Tile colour dots (snippets/product-card.liquid): a dot switches the tile to that colourway in place and never
    // follows the tile link. Its face (photos and sizes, its sizes put away) shows, its photos loading the first time,
    // the link and colour name follow, and the price line too when it reads differently. The lead photo eases in,
    // except back on the colour the tile opened with (unhiding a face restarts it); a fresh name span rises in again,
    // as the site's keyed span does.
    const tileDot = e.target.closest('[data-tile-dot]');
    if (tileDot) {
      e.preventDefault();
      e.stopPropagation();
      const tile = tileDot.closest('[data-tile]');
      if (!tile) return;
      const dots = $$('[data-tile-dot]', tile);
      const faces = $$('[data-tile-face]', tile);
      const n = dots.indexOf(tileDot);
      if (!faces[n] || !faces[n].hidden) return;
      $$('[data-quick][data-open]', tile).forEach((root) => setQuickOpen(root, false));
      $$('img[data-src]', faces[n]).forEach((img) => {
        img.srcset = img.dataset.srcset || '';
        img.src = img.dataset.src;
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
      });
      faces.forEach((face, i) => (face.hidden = i !== n));
      $('img', faces[n])?.classList.toggle(TILE_SWAP, n !== Number(tile.dataset.tile));
      tile.href = tileDot.dataset.url;
      dots.forEach((dot, i) => {
        const on = i === n;
        dot.setAttribute('aria-pressed', String(on));
        dot.classList.toggle('border-ink', on);
        dot.classList.toggle('border-transparent', !on);
        dot.classList.toggle('hover:border-ink/30', !on);
        const fill = $('span', dot);
        fill?.classList.remove(...(on ? DOT_OFF : DOT_ON));
        fill?.classList.add(...(on ? DOT_ON : DOT_OFF));
      });
      const name = $('[data-tile-colour]', tile);
      if (name && name.textContent !== tileDot.title) {
        const next = name.cloneNode(false);
        next.textContent = tileDot.title;
        name.replaceWith(next);
      }
      const prices = $$('[data-tile-price]', tile);
      const shown = prices.find((p) => !p.hidden);
      if (prices[n] && shown && prices[n].innerHTML !== shown.innerHTML) prices.forEach((p, i) => (p.hidden = i !== n));
      return;
    }
    // Complete the set (site CompleteTheSet): Add adds at once when a size is already chosen for this card
    // or only one size is available; otherwise the size row slides over it. Picking a size adds it, hides
    // the row, remembers the size and shows "Added" for 1800ms.
    const ctsBtn = e.target.closest('[data-cts-variant], [data-cts-add]');
    if (ctsBtn) {
      e.preventDefault();
      const card = ctsBtn.closest('[data-cts-card]');
      const add = $('[data-cts-add]', card);
      const sizes = $('[data-cts-sizes]', card);
      const done = (id) => {
        card.dataset.ctsChosen = id;
        sizes?.classList.remove('translate-y-0', 'opacity-100');
        sizes?.classList.add('pointer-events-none', 'translate-y-1', 'opacity-0');
        if (add) {
          add.classList.remove('pointer-events-none', 'opacity-0');
          add.classList.add('opacity-100');
          add.setAttribute('aria-label', add.dataset.ctsLabel);
          add.textContent = window.Vesari?.strings?.added || 'Added';
          setTimeout(() => (add.textContent = window.Vesari?.strings?.add || 'Add'), 1800);
        }
        return addToCart(id);
      };
      if (ctsBtn.dataset.ctsVariant) {
        await done(ctsBtn.dataset.ctsVariant);
        return;
      }
      const id = card.dataset.ctsChosen || ctsBtn.dataset.ctsSingle;
      if (id) {
        await done(id);
        return;
      }
      ctsBtn.classList.remove('opacity-100');
      ctsBtn.classList.add('pointer-events-none', 'opacity-0');
      ctsBtn.removeAttribute('aria-label');
      sizes?.classList.remove('pointer-events-none', 'translate-y-1', 'opacity-0');
      sizes?.classList.add('translate-y-0', 'opacity-100');
      return;
    }
    // Pair it perfectly: add the chosen size; the piece then leaves the list and the next slides in. With no
    // size chosen, Add opens the size list (showPicker, else focus) and marks it instead. A one-size piece has no
    // list: its Add carries the variant (data-pair-variant) and adds it straight away.
    const pairAdd = e.target.closest('[data-pair-add]');
    if (pairAdd) {
      if (pairAdd.dataset.pairVariant) {
        if (pairAdd.disabled) return;
        pairAdd.disabled = true;
        await addToCart(pairAdd.dataset.pairVariant);
        pairAdd.disabled = false;
        return;
      }
      const item = pairAdd.closest('[data-pair-item]');
      const select = item && $('[data-pair-size]', item);
      if (!select || pairAdd.disabled) return;
      if (!select.value) {
        pairNudge = item.dataset.handle;
        markPair(select, true);
        try {
          select.showPicker();
        } catch {
          select.focus();
        }
        return;
      }
      pairAdd.disabled = true;
      await addToCart(select.value);
      pairAdd.disabled = false;
      return;
    }
    // Bag lines (drawer stepper, Remove on both): the quantity comes from the page and shows at once,
    // + stops at 10 (the site's Math.min(10, qty + 1)), and the requests queue so fast taps each count.
    const step = e.target.closest('[data-line-minus], [data-line-plus], [data-line-remove]');
    const line = step?.closest('[data-key]');
    if (line) {
      const shown = $('[data-line-qty-text]', line);
      const current = Number(shown ? shown.textContent : line.dataset.qty) || 0;
      const next = step.hasAttribute('data-line-remove') ? 0 : Math.min(10, Math.max(0, current + (step.hasAttribute('data-line-plus') ? 1 : -1)));
      if (next === current) return;
      if (shown && next > 0) shown.textContent = next;
      line.dataset.qty = next;
      await cartRequest(window.Vesari.routes.cart_change, { id: line.dataset.key, quantity: next });
    }
  });

  /* ---------- product purchase panel ---------- */
  // Mirrors the site's PurchasePanel + SizeButtons. One selection per option: colour starts on its first
  // swatch (as does any single-value option), sizes are never preselected. The variant comes from the
  // product JSON; the price and compare line follow it (the cheapest variant until every option is
  // chosen). Sold-out sizes are greyed and struck, the button asks for a size (and nudges the rows into
  // view) until the selection is complete, "Added to bag" stays until the next change, and phones get a
  // pinned bar while the inline button is off screen. Adds go through addToCart (cart block above).
  $$('[data-purchase-panel]').forEach((panel) => {
    let data = {};
    try {
      data = JSON.parse($('[data-product-json]', panel)?.textContent || '{}');
    } catch {}
    const options = data.options || [];
    const variants = data.variants || [];
    if (!variants.length) return;
    const isGift = panel.hasAttribute('data-gift');
    const colourIndex = options.findIndex((o) => /colou?r/i.test(o.name));
    const sizeCount = options.filter((o) => !/colou?r|title/i.test(o.name)).length;
    const chooseLabel = isGift ? 'Choose an amount' : sizeCount > 1 ? 'Choose a size for each piece' : 'Choose a size';
    const selection = options.map((o, i) => (o.values.length === 1 || i === colourIndex ? o.values[0] : ''));
    const base = [...variants].sort((a, b) => a.price - b.price)[0];
    const form = $('form', panel);
    const idInput = $('[data-variant-id]', panel);
    const sizes = $('[data-options]', panel);
    const button = $('[data-add-button]', panel);
    const inline = $('[data-inline-buy]', panel);
    const bar = $('[data-buy-bar]', panel);
    const barButton = $('[data-buy-bar-button]', panel);
    const barPrice = bar && $('[data-price]', bar);
    const prices = $$('[data-price]', panel);
    const compare = $('[data-compare]', panel);
    const rows = $$('[data-size-row]', panel);
    const swatches = $$('[data-swatch]', panel);
    const lowNotes = $$('[data-low-stock]', panel);
    let lowNote = lowNotes[lowNotes.length - 1];   // beside the last size row's chosen size
    let stock = {};
    try {
      stock = JSON.parse($('[data-stock]', panel)?.textContent || '{}');
    } catch {}
    let colourName = $('[data-colour-name]', panel);
    let added = false;
    let nudge = false;
    let preview = null;
    let adding = 0;
    let pending = false;

    const PRICE_IN = 'inline-block animate-[price-in_450ms_cubic-bezier(0.22,1,0.36,1)]';
    const SIZE_STATES = ['border-transparent', 'text-ink', 'border-ink/15', 'hover:border-ink', 'border-ink/10', 'text-ink/35', 'border-ink/60'];
    const STRIKE = 'absolute inset-0 rounded-[6px] bg-[linear-gradient(to_top_right,transparent_calc(50%-0.5px),rgb(17_17_17/0.18)_50%,transparent_calc(50%+0.5px))]';
    const SMALL = new Set(['and', 'of', 'the', 'in', 'for', 'with', 'x']);
    const displayTitle = (t) =>
      t
        .toLowerCase()
        .replace(/\bcherie\b/g, 'chérie')
        .split(/(\s+|\/)/)
        .map((w, i) => (SMALL.has(w) && i > 0 ? w : w.charAt(0).toUpperCase() + w.slice(1)))
        .join('');
    // "CHÉRIE COURT SKIRT (Size)" -> "Skirt"; the chosen line reads "S", "$100" or "Skirt XS · Top M".
    const pieceShortName = (name) => {
      const b = name.replace(/\s*\(size\)\s*/i, '').trim();
      return displayTitle(b.split(/\s+/).pop() ?? b);
    };
    const variantLabel = (v) => {
      const parts = options.map((o, i) => ({ o, value: v.options[i] })).filter(({ o }) => !/^(title|colou?r)$/i.test(o.name));
      if (parts.length === 0) return '';
      if (parts.length === 1) return parts[0].value;
      return parts.map(({ o, value }) => `${pieceShortName(o.name)} ${value}`).join(' · ');
    };
    const current = () => {
      const complete = selection.every(Boolean);
      return { complete, variant: complete ? variants.find((v) => v.options.every((o, i) => o === selection[i])) : undefined };
    };
    // Whether choosing `value` for option i (keeping the other choices) can still lead to an in-stock variant.
    const availableFor = (i, value) =>
      variants.some((v) => v.available && v.options[i] === value && v.options.every((o, j) => j === i || !selection[j] || o === selection[j]));

    // The black outline travels to the chosen size; with nothing chosen it waits shrunk and hidden, so the
    // first pick pops in from 0.9 with the overshoot curve.
    const positionGlider = (row) => {
      const glider = $('[data-size-glider]', row);
      if (!glider) return;
      const chosen = selection[Number(row.dataset.optionIndex)];
      const on = chosen ? $$('[data-size]', row).find((l) => $('input', l).value === chosen) : undefined;
      glider.classList.remove(...(on ? ['scale-90', 'opacity-0'] : ['scale-100', 'opacity-100']));
      glider.classList.add(...(on ? ['scale-100', 'opacity-100'] : ['scale-90', 'opacity-0']));
      glider.style.left = on ? `${on.offsetLeft}px` : '';
      glider.style.top = on ? `${on.offsetTop}px` : '';
      glider.style.width = on ? `${on.offsetWidth}px` : '';
      glider.style.height = on ? `${on.offsetHeight}px` : '';
    };

    // The colour name rises in again whenever the name shown changes (hover preview or a new choice):
    // a fresh span restarts its animation, as the site's keyed span does.
    const showColourName = () => {
      if (!colourName) return;
      const text = displayTitle(preview ?? selection[colourIndex] ?? '');
      if (colourName.textContent === text) return;
      const next = colourName.cloneNode(false);
      next.textContent = text;
      colourName.replaceWith(next);
      colourName = next;
    };

    // Price shown: the chosen variant's, else the cheapest variant's; compare-at only when above that price.
    const priceFor = (variant) => {
      const v = variant || base;
      return { price: v.price, compareAt: v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null };
    };
    // Liquid rendered the same starting price and compare line, so the text is only rewritten when the
    // amount changes (keeping Shopify's own money formatting until then).
    let shown = priceFor(current().variant);

    const render = () => {
      const { complete, variant } = current();
      const { price, compareAt } = priceFor(variant);
      if (idInput) idInput.value = variant ? variant.id : '';
      // Only the text changes: the amount rises in on load (and on a currency change), not per variant.
      if (price !== shown.price) prices.forEach((el) => (el.textContent = money(price)));
      if (compare && (price !== shown.price || compareAt !== shown.compareAt)) {
        if (compareAt) {
          let struck = compare.firstElementChild;
          if (!struck) {
            compare.className = 'num mt-1.5 text-[12px] text-ink-2';
            struck = document.createElement('span');
            struck.className = `${PRICE_IN} line-through`;
            compare.replaceChildren(struck, document.createTextNode(''));
          }
          struck.textContent = money(compareAt);
          (struck.nextSibling || compare.appendChild(document.createTextNode(''))).textContent = ` · Save ${Math.round((1 - price / compareAt) * 100)}%`;
        } else if (compare.firstElementChild) {
          compare.className = 'mt-1.5 text-[11px] text-ink-2';
          compare.textContent = compare.dataset.currency || '';
        }
      }
      shown = { price, compareAt };

      // Real stock only: the chosen size with 20 or fewer left says so beside it (the site's lowStock).
      if (lowNote) {
        const left = variant?.available ? stock[variant.id] : null;
        const low = typeof left === 'number' && left > 0 && left <= 20;
        const text = low ? `· Only ${left} left` : '';
        if (lowNote.textContent !== text) {
          // a fresh node restarts the rise-in, as the site's keyed span does
          const next = lowNote.cloneNode(false); next.textContent = text; lowNote.replaceWith(next); lowNote = next;
        }
        lowNote.hidden = !low;
      }
      const label = !complete ? chooseLabel : !variant?.available ? 'Sold out in this size' : added ? 'Added to bag' : 'Add to bag';
      const canAdd = !complete || Boolean(variant?.available);
      if (button) {
        if (button.textContent !== label) button.textContent = label;
        button.disabled = !canAdd;
      }
      if (barButton) {
        const barLabel = complete ? label : isGift ? 'Choose amount' : 'Choose size';
        if (barButton.textContent !== barLabel) barButton.textContent = barLabel;
        barButton.disabled = !canAdd;
      }
      if (barPrice) {
        const chosen = complete && variant ? variantLabel(variant) : '';
        (barPrice.nextSibling || barPrice.parentNode.appendChild(document.createTextNode(''))).textContent = chosen ? ` · ${chosen}` : '';
      }

      $$('[data-option-input]', panel).forEach((input) => {
        input.checked = selection[Number(input.dataset.optionIndex)] === input.value;
      });

      swatches.forEach((l) => {
        const on = $('input', l).value === selection[colourIndex];
        l.classList.toggle('border-ink', on);
        l.classList.toggle('border-transparent', !on);
        l.classList.toggle('hover:border-ink/30', !on);
        const dot = $('[data-swatch-dot]', l);
        if (!dot) return;
        dot.classList.toggle('h-[18px]', on);
        dot.classList.toggle('w-[18px]', on);
        dot.classList.toggle('h-[22px]', !on);
        dot.classList.toggle('w-[22px]', !on);
      });
      showColourName();

      rows.forEach((row) => {
        const i = Number(row.dataset.optionIndex);
        const chosen = selection[i];
        $$('[data-size]', row).forEach((l) => {
          const input = $('input', l);
          const value = input.value;
          const ok = availableFor(i, value);
          // The chosen state wins over stock; the strike and ", sold out" stay on a chosen sold-out size.
          l.classList.remove(...SIZE_STATES);
          l.classList.add(...(value === chosen ? ['border-transparent', 'text-ink'] : ok ? ['border-ink/15', 'text-ink', 'hover:border-ink'] : ['border-ink/10', 'text-ink/35']));
          if (nudge && !chosen) l.classList.add('border-ink/60');
          input.setAttribute('aria-label', `${value}${ok ? '' : ', sold out'}`);
          const strike = l.querySelector(':scope > span[aria-hidden]');
          if (!ok && !strike) {
            const s = document.createElement('span');
            s.setAttribute('aria-hidden', 'true');
            s.className = STRIKE;
            input.after(s);
          } else if (ok && strike) strike.remove();
        });
        const legend = $('[data-size-label]', row.closest('fieldset'));
        if (legend) {
          const prompt = nudge && !chosen;
          legend.textContent = chosen || (prompt ? (isGift ? 'Choose an amount' : 'Choose a size') : '');
          legend.classList.toggle('text-ink', prompt);
          legend.classList.toggle('text-ink-2', !prompt);
        }
        positionGlider(row);
      });
    };

    const add = () => {
      const { complete, variant } = current();
      if (!complete) {
        nudge = true;
        render();
        // Bring the size rows into view under the fixed header, not the button below them.
        if (sizes) window.scrollTo({ top: sizes.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
        return;
      }
      if (!variant || !variant.available) return;
      added = true;
      render();
      const token = ++adding;
      pending = true;
      Promise.resolve()
        .then(() => addToCart(variant.id, 1))
        .then((res) => {
          if (res === false || (res && (res.ok === false || (typeof res.status === 'number' && res.status >= 400)))) throw new Error('add failed');
        })
        .catch(() => {
          // Nothing was added: drop the "Added to bag" label (unless a later add or change took over).
          if (token === adding && added) {
            added = false;
            render();
          }
        })
        .finally(() => token === adding && (pending = false));
    };
    // Taken back out of the bag (drawer or /cart): the button reads "Add to bag" again, as the site's.
    addEventListener('vesari:cart', () => {
      if (!added || pending || !drawer) return;
      const { variant } = current();
      if (variant && !$(`li[data-variant-id="${variant.id}"]`, drawer)) {
        added = false;
        render();
      }
    });

    panel.addEventListener('change', (e) => {
      const input = e.target.closest('[data-option-input]');
      if (!input) return;
      selection[Number(input.dataset.optionIndex)] = input.value;
      added = false;
      nudge = false;
      render();
    });
    // Hovering a swatch previews its name; leaving the row returns to the chosen colour.
    swatches.forEach((l) =>
      l.addEventListener('pointerenter', () => {
        preview = $('input', l).value;
        showColourName();
      }),
    );
    // The new line's other colourways are links to their own products; they preview their name too.
    $$('[data-swatch-link]', panel).forEach((a) => {
      const on = () => {
        preview = a.dataset.colour;
        showColourName();
      };
      a.addEventListener('pointerenter', on);
      a.addEventListener('focus', on);
      a.addEventListener('blur', () => {
        preview = null;
        showColourName();
      });
    });
    $('[data-swatch-row]', panel)?.addEventListener('pointerleave', () => {
      preview = null;
      showColourName();
    });
    button?.addEventListener('click', add);
    barButton?.addEventListener('click', add);
    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      add();
    });
    if ('ResizeObserver' in window) rows.forEach((row) => new ResizeObserver(() => positionGlider(row)).observe(row));

    // Phones: pin a slim add-to-bag bar once the inline Add to bag button itself ([data-inline-buy]) has gone up under
    // the fixed header (so it never covers the photos), except over the footer.
    if (bar && inline) {
      let raf = 0;
      const check = () => {
        raf = 0;
        const r = inline.getBoundingClientRect();
        const footer = $('footer')?.getBoundingClientRect();
        // Gone = tucked under the fixed header, not only past the top edge.
        const top = $('[data-header-bar]')?.getBoundingClientRect().bottom ?? 0;
        const show = r.bottom < top && !(footer && footer.top < window.innerHeight);
        bar.classList.toggle('translate-y-0', show);
        bar.classList.toggle('translate-y-full', !show);
        bar.setAttribute('aria-hidden', String(!show));
        barButton?.setAttribute('tabindex', show ? '0' : '-1');
      };
      const onScroll = () => {
        if (!raf) raf = requestAnimationFrame(check);
      };
      check();
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll);
    }

    render();
  });

  /* ---------- endless carousels ---------- */
  // Mirrors the site's LoopCarousel. The items are shown three times with the originals as the
  // middle copy (the outer copies are aria-hidden) and the track starts on that middle copy;
  // whenever scrolling settles in an outer copy it jumps silently by one copy width, so it never
  // runs out. Swipe on phones, drag with the mouse on desktop, and the edge buttons step it.
  const initLoop = (root) => {
    if (!root || root.hasAttribute('data-loop-ready')) return;
    const track = $('[data-loop-track]', root);
    if (!track) return;
    const originals = $$('[data-loop-item]', track);
    const n = originals.length;
    if (n === 0) return;
    root.setAttribute('data-loop-ready', '');
    const copy = () =>
      originals.map((el) => {
        const c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        // Theme editor: only the originals may answer to a block, or selecting one scrolls to a copy.
        c.removeAttribute('data-shopify-editor-block');
        // The copies stay clickable, since they are what is on screen while the strip wraps, but leave the Tab
        // order: a keyboard visits each piece once.
        $$('a[href], button, input, select, textarea, [tabindex]', c).forEach((node) => (node.tabIndex = -1));
        return c;
      });
    track.prepend(...copy());
    track.append(...copy());

    const kids = track.children;
    const zones = $$('[data-loop-prev], [data-loop-next]', root);
    const pitch = () => (kids[0] && kids[1] ? kids[1].offsetLeft - kids[0].offsetLeft : 0);
    const copyWidth = () => (kids[0] && kids[n] ? kids[n].offsetLeft - kids[0].offsetLeft : 0);
    // Centred rows (--centred on the track, the home row from lg): the gap left over beside the whole cards is split
    // between the two sides. Snapping keeps that inset, and the edge zones narrow to it, so they cover only the peeking
    // neighbours (and take the pointer there).
    let inset = 0;
    const measureInset = () => {
      let p = 0;
      const w = pitch();
      if (kids[0] && w && getComputedStyle(track).getPropertyValue('--centred').trim() === '1') {
        const gap = w - kids[0].offsetWidth;
        const whole = Math.max(1, Math.floor((track.clientWidth + gap) / w));
        p = Math.max(0, (track.clientWidth - whole * kids[0].offsetWidth - (whole - 1) * gap) / 2);
      }
      inset = p;
      track.style.scrollPaddingLeft = p ? `${p}px` : '';
      zones.forEach((z) => {
        z.style.width = p ? `${p}px` : '';
        z.style.pointerEvents = p ? 'auto' : '';
      });
      return p;
    };
    // The track is scroll-smooth, so every silent jump turns smooth scrolling off first.
    const jump = (left) => {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = left;
      track.style.scrollBehavior = '';
    };
    const centre = () => jump(copyWidth() - measureInset());
    centre();
    addEventListener('resize', centre);

    let drag = null;
    let settle = 0;
    track.addEventListener(
      'scroll',
      () => {
        const cw = copyWidth();
        clearTimeout(settle);
        settle = setTimeout(() => {
          if (drag) return;
          if (track.scrollLeft < cw * 0.5) jump(track.scrollLeft + cw);
          else if (track.scrollLeft > cw * 1.5) jump(track.scrollLeft - cw);
        }, 140);
      },
      { passive: true },
    );

    const step = (d) => track.scrollBy({ left: d * pitch(), behavior: 'smooth' });
    $('[data-loop-prev]', root)?.addEventListener('click', () => step(-1));
    $('[data-loop-next]', root)?.addEventListener('click', () => step(1));
    // A click must not focus a zone (it is out of the tab order), or the next key press draws a focus ring round the peek.
    zones.forEach((z) => z.addEventListener('mousedown', (e) => e.preventDefault()));

    // The edge zone under the pointer, if any. The zones let the pointer through to the cards (so a card at the edge
    // still shows its sizes), and a card's own controls (sizes, "+", Shop the look, Shop the piece) are never part of
    // a zone. data-edge on the root gives the cursor its arrow; a click there steps instead of opening the card. On touch
    // screens the zones are display:none (md:pointer-fine:block), so with no width they never match and a tap opens the card.
    const edgeAt = (x, y, target) => {
      if (target instanceof Element && target.closest('[data-cursor-native], button')) return null;
      for (const z of zones) {
        const r = z.getBoundingClientRect();
        if (r.width && x >= r.left && x < r.right && y >= r.top && y < r.bottom) return z.hasAttribute('data-loop-prev') ? 'prev' : 'next';
      }
      return null;
    };
    const setEdge = (side) => {
      if (side) root.dataset.edge = side;
      else delete root.dataset.edge;
    };
    root.addEventListener('pointermove', (e) => setEdge(edgeAt(e.clientX, e.clientY, e.target)));
    root.addEventListener('pointerleave', () => setEdge(null));
    root.addEventListener(
      'click',
      (e) => {
        // A drag's click is cancelled by the track; keyboard clicks (detail 0) are never an edge.
        if (e.detail === 0 || drag?.moved) return;
        const side = edgeAt(e.clientX, e.clientY, e.target);
        if (!side) return;
        e.preventDefault();
        e.stopPropagation();
        step(side === 'prev' ? -1 : 1);
      },
      true,
    );

    // Desktop drag-to-scroll (mouse only; touch uses native swipe). Snap is off while dragging,
    // then the strip settles on the nearest card.
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false };
      track.style.scrollSnapType = 'none';
    });
    track.addEventListener('pointermove', (e) => {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      if (Math.abs(dx) > 4) drag.moved = true;
      track.scrollLeft = drag.left - dx;
    });
    const endDrag = () => {
      if (!drag) return;
      track.style.scrollSnapType = '';
      const w = pitch();
      if (w) track.scrollTo({ left: Math.round((track.scrollLeft + inset) / w) * w - inset, behavior: 'smooth' });
      setTimeout(() => (drag = null), 0);
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener(
      'click',
      (e) => {
        if (drag?.moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true,
    );
    // No native ghost-image drag of a slide's photo or link.
    track.addEventListener('dragstart', (e) => e.preventDefault());

    // Step forward on its own every N ms; paused while hovered, while touched and for 2.5s after.
    let hold = false;
    root.addEventListener('mouseenter', () => (hold = true));
    root.addEventListener('mouseleave', () => (hold = false));
    root.addEventListener('touchstart', () => (hold = true), { passive: true });
    root.addEventListener('touchend', () => setTimeout(() => (hold = false), 2500));
    const auto = Number(root.dataset.autoplay || 0);
    if (auto && !reduced) {
      setInterval(() => {
        if (hold || drag || document.hidden) return;
        track.scrollBy({ left: pitch(), behavior: 'smooth' });
      }, auto);
    }
  };
  window.Vesari = window.Vesari || {};
  window.Vesari.initLoop = initLoop;
  $$('[data-loop-carousel]').forEach((root) => initLoop(root));
  // Theme editor: a re-rendered section brings a fresh, uninitialised carousel.
  document.addEventListener('shopify:section:load', (e) => $$('[data-loop-carousel]', e.target).forEach((root) => initLoop(root)));

  /* ---------- Loved by you: a tap or click swaps a review card for the piece ---------- */
  // Delegated, so the carousel's copies toggle too. The button inside still navigates, and a
  // drag-click never reaches here (the track cancels it in the capture phase).
  document.addEventListener('click', (e) => {
    if (!(e.target instanceof Element) || e.target.closest('a')) return;
    const card = e.target.closest('[data-review-card]');
    if (!card) return;
    if (card.hasAttribute('data-open')) card.removeAttribute('data-open');
    else card.setAttribute('data-open', 'true');
  });

  /* ---------- the "View" cursor ---------- */
  const bubble = $('[data-cursor-bubble]');
  if (bubble && matchMedia('(hover: hover) and (pointer: fine)').matches && !reduced) {
    // The bubble replaces the pointer over [data-cursor] hosts (src/theme.css), so the class is only added once the bubble is live.
    document.documentElement.classList.add('cursor-bubble-on');
    // lucide ArrowLeft / ArrowRight at size 20, strokeWidth 1.25
    const ARROWS = {
      prev: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>',
      next: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>',
    };
    let current = null;
    const setLabel = (text) => {
      if (text === current) return;
      current = text;
      if (text && ARROWS[text]) bubble.innerHTML = ARROWS[text];
      else bubble.textContent = text || '';
      bubble.classList.toggle('scale-100', !!text);
      bubble.classList.toggle('opacity-100', !!text);
      bubble.classList.toggle('scale-50', !text);
      bubble.classList.toggle('opacity-0', !text);
    };
    // Placed on every mouse move with no easing, so it moves like the mouse itself. It shows strictly over a photo.
    addEventListener(
      'mousemove',
      (e) => {
        bubble.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0) translate(-50%, -50%)`;
        const el = e.target instanceof Element ? e.target : null;
        // Strictly over a photo (as the site): gaps between tiles and the text under them keep the normal pointer.
        if (!el || el.closest('[data-cursor-native]') || !el.closest('img, video')) return setLabel(null);
        // A carousel marks the edge zone the pointer is in (initLoop), over whatever card lies beneath.
        const edge = el.closest('[data-edge]');
        if (edge) return setLabel(edge.dataset.edge || null);
        const host = el.closest('[data-cursor]');
        setLabel(host ? host.dataset.cursor || 'View' : null);
      },
      { passive: true },
    );
    document.documentElement.addEventListener('mouseleave', () => setLabel(null));
  }

  /* ---------- gallery films ---------- */
  // Product films in the gallery play only while on screen, and never with reduced motion (as the site's GalleryVideo).
  if (!reduced && 'IntersectionObserver' in window) {
    const filmWatch = new IntersectionObserver(
      (entries) => entries.forEach((e) => (e.isIntersecting ? e.target.play().catch(() => {}) : e.target.pause())),
      { threshold: 0.25 },
    );
    $$('[data-gallery-video]').forEach((v) => filmWatch.observe(v));
  }

  /* ---------- gallery lightbox ---------- */
  const lightbox = $('[data-lightbox]');
  if (lightbox) {
    let images = [];
    try { images = JSON.parse($('[data-lightbox-data]', lightbox).textContent) || []; } catch {}
    const title = lightbox.dataset.lightboxTitle || '';
    const stage = $('[data-lightbox-stage]', lightbox);
    const counter = $('[data-lightbox-counter]', lightbox);
    let index = 0;
    // Inert while closed; open, focus is held inside and goes back to the photo that opened it (holdFocus).
    let release = null;
    const show = (i) => {
      if (!images.length) return;
      index = (i + images.length) % images.length;
      const src = images[index];
      stage.replaceChildren();
      if (src && typeof src === 'object' && src.video) {
        // A product film (as the site's viewer): muted, looping, with controls.
        const v = document.createElement('video');
        Object.assign(v, { src: src.video, poster: src.poster || '', muted: true, loop: true, playsInline: true, controls: true, autoplay: true });
        v.className = 'absolute inset-0 h-full w-full object-contain';
        stage.append(v);
      } else if (src) {
        const img = document.createElement('img');
        img.src = src;
        img.alt = `${title}, view ${index + 1}`;
        img.className = 'h-full w-full object-contain';
        stage.append(img);
      }
      if (counter) counter.textContent = `${index + 1} / ${images.length}`;
    };
    const open = (i) => {
      show(i);
      lightbox.setAttribute('aria-hidden', 'false');
      lightbox.removeAttribute('inert');
      lightbox.classList.remove('pointer-events-none', 'opacity-0');
      document.body.style.overflow = 'hidden';
      if (!release) release = holdFocus(lightbox);
    };
    // The photo leaves at once; only the black layer fades out.
    const close = () => {
      stage.replaceChildren();
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.setAttribute('inert', '');
      lightbox.classList.add('pointer-events-none', 'opacity-0');
      document.body.style.overflow = '';
      release?.();
      release = null;
    };
    // Phone swipe: more than 40px sideways steps one photo.
    let touchX = null;
    lightbox.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', (e) => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
      touchX = null;
    });
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-gallery-open]');
      if (opener) open(Number(opener.dataset.galleryOpen));
      if (e.target.closest('[data-lightbox-close]')) close();
      if (e.target.closest('[data-lightbox-prev]')) show(index - 1);
      if (e.target.closest('[data-lightbox-next]')) show(index + 1);
    });
    addEventListener('keydown', (e) => {
      if (lightbox.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(index + 1);
      if (e.key === 'ArrowLeft') show(index - 1);
    });
  }

  /* ---------- phone gallery counter ---------- */
  const gallery = $('[data-gallery]');
  const galleryCounter = $('[data-gallery-counter]');
  if (gallery && galleryCounter) {
    gallery.addEventListener('scroll', () => {
      const w = gallery.clientWidth || 1;
      galleryCounter.textContent = `${Math.round(gallery.scrollLeft / w) + 1} / ${gallery.children.length}`;
    }, { passive: true });
  }

  /* ---------- currency menus ---------- */
  // Closed, a list is inert (out of reach of Tab). The header's switch is a plain disclosure (snippets/currency-switch):
  // closing it from inside (Escape, or picking a currency) hands focus back to its button, as the site's CurrencySwitch.
  $$('[data-currency-trigger]').forEach((trigger) => {
    const list = trigger.parentElement.querySelector('[data-currency-list]');
    if (!list) return;
    const disclosure = Boolean(trigger.closest('[data-currency-switch]'));
    const setOpen = (open) => {
      if (!open && disclosure && list.contains(document.activeElement)) trigger.focus({ preventScroll: true });
      list.toggleAttribute('inert', !open);
      trigger.setAttribute('aria-expanded', String(open));
      trigger.querySelector('[data-currency-chevron]')?.classList.toggle('rotate-180', open);
      list.classList.toggle('pointer-events-none', !open);
      list.classList.toggle('opacity-0', !open);
      list.classList.toggle('scale-95', !open);
      list.classList.toggle('translate-y-2', !open && list.classList.contains('bottom-full'));
      list.classList.toggle('-translate-y-1', !open && !list.classList.contains('bottom-full'));
    };
    trigger.addEventListener('click', () => setOpen(trigger.getAttribute('aria-expanded') !== 'true'));
    document.addEventListener('pointerdown', (e) => !trigger.parentElement.contains(e.target) && setOpen(false));
    addEventListener('keydown', (e) => e.key === 'Escape' && setOpen(false));
    // Picking a currency closes the header's menu at once (the localization form then reloads the page in it).
    if (disclosure) trigger.form?.addEventListener('submit', () => setOpen(false));
  });

  /* ---------- newsletter sign-up: one handler for every form[data-newsletter] (footer, Join pill clones, OCA page, PDP notify) ---------- */
  {
    const NEWSLETTER_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const newsletterTone = (form) => (form.dataset.newsletterTone === 'inverse' ? 'text-paper' : 'text-ink');
    const newsletterField = (form) => form.querySelector('input[type="email"]');
    const clearNewsletterError = (form) => {
      form.querySelectorAll('[role="alert"]').forEach((n) => n.remove());
      const input = newsletterField(form);
      input?.removeAttribute('aria-invalid');
      input?.removeAttribute('aria-describedby');
    };
    const showNewsletterError = (form, msg) => {
      clearNewsletterError(form);
      const p = document.createElement('p');
      p.id = `${form.dataset.newsletter}-msg`;
      p.setAttribute('role', 'alert');
      p.className = `text-[13px] ${newsletterTone(form)}`;
      p.textContent = msg;
      form.append(p);
      const input = newsletterField(form);
      input?.setAttribute('aria-invalid', 'true');
      input?.setAttribute('aria-describedby', p.id);
    };
    // Window + capture phase: runs before Shopify's captcha listener on document, and needs no rebinding for cloned forms.
    addEventListener('submit', async (e) => {
      const form = e.target instanceof Element ? e.target.closest('form[data-newsletter]') : null;
      if (!form) return;
      // Second pass after a refused background post: let it through to Shopify's spam check, which adds its token and posts natively.
      if (form.dataset.newsletterNative === '1') {
        delete form.dataset.newsletterNative;
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      const input = newsletterField(form);
      const button = form.querySelector('[type="submit"]');
      const label = form.querySelector('[data-newsletter-label]');
      if (!input || button?.disabled) return;
      if (label && label.dataset.cta == null) label.dataset.cta = label.textContent;
      clearNewsletterError(form);
      const email = input.value.trim().toLowerCase();
      if (!NEWSLETTER_EMAIL.test(email)) {
        showNewsletterError(form, 'Enter a valid email address.');
        return;
      }
      if (button) button.disabled = true;
      if (label) label.textContent = 'Sending';
      let ok = false;
      try {
        const body = new FormData(form);
        body.set('contact[email]', email);
        const res = await fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new URLSearchParams(body) });
        const url = new URL(res.url, location.href);
        // Bot protection: hand the post to Shopify natively so the shopper can pass the challenge.
        if (/\/challenge\/?$/.test(url.pathname)) {
          input.value = email;
          form.dispatchEvent(new CustomEvent('newsletter:challenge', { bubbles: true }));
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        // Shopify's hCaptcha protection refuses a post without its token (400 "Missing CAPTCHA token", or 403/429):
        // resubmit natively so its script runs the check, adds the token and posts the form itself.
        if (res.status === 400 || res.status === 403 || res.status === 429) {
          input.value = email;
          form.dispatchEvent(new CustomEvent('newsletter:challenge', { bubbles: true }));
          form.dataset.newsletterNative = '1';
          if (button) button.disabled = false;
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else HTMLFormElement.prototype.submit.call(form);
          return;
        }
        // Shopify redirects to a 200 page whether or not the post worked; only customer_posted=true means it did.
        ok = url.searchParams.get('customer_posted') === 'true';
      } catch {}
      if (ok) {
        // A form that owns its own thank-you (the welcome offer's code step) is told, and keeps its markup.
        form.dispatchEvent(new CustomEvent('newsletter:done', { bubbles: true }));
        if (form.dataset.newsletterDone === 'event') {
          if (button) button.disabled = false;
          if (label) label.textContent = label.dataset.cta;
          return;
        }
        const done = document.createElement('p');
        done.setAttribute('role', 'status');
        done.className = `text-sm ${newsletterTone(form)}`;
        done.textContent = 'You’re on the list. We’ll write when the next drop is ready.';
        form.replaceWith(done);
        return;
      }
      if (button) button.disabled = false;
      if (label) label.textContent = label.dataset.cta;
      showNewsletterError(form, 'We couldn’t save that email just now. Please try again.');
    }, true);
    // Back from a native post (hCaptcha path): Shopify reloads with ?customer_posted=true#<form id>; thank the shopper in place.
    if (new URLSearchParams(location.search).get('customer_posted') === 'true' && location.hash.length > 1) {
      const posted = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (posted instanceof HTMLFormElement && posted.matches('form[data-newsletter]') && posted.dataset.newsletterDone !== 'event') {
        const done = document.createElement('p');
        done.setAttribute('role', 'status');
        done.className = `text-sm ${newsletterTone(posted)}`;
        done.textContent = 'You’re on the list. We’ll write when the next drop is ready.';
        posted.replaceWith(done);
      }
    }
    // Typing clears the error, as the site's onChange does.
    addEventListener('input', (e) => {
      const form = e.target instanceof Element ? e.target.closest('form[data-newsletter]') : null;
      if (form && e.target.matches('input[type="email"]')) clearNewsletterError(form);
    }, true);
  }

  /* ---------- join the list pill ---------- */
  const pill = $('[data-join-pill]');
  // Closed with its × once: gone for good in this browser.
  // v2: a tap on the "+" used to land on the × and hide the pill by mistake, so dismissals from before that fix are forgotten.
  const JOIN_DISMISSED = 'vesari:join-dismissed:v2';
  let joinClosed = false;
  try {
    joinClosed = localStorage.getItem(JOIN_DISMISSED) === '1';
  } catch {}
  if (pill && joinClosed) pill.remove();
  else if (pill) {
    const toggle = $('[data-join-toggle]', pill);
    const card = $('[data-join-card]', pill);
    const joinLabel = $('[data-join-label]', pill);
    const barA = $('[data-join-bar-a]', pill);
    const barB = $('[data-join-bar-b]', pill);
    const slot = $('[data-join-slot]', pill);
    const formTpl = $('template[data-join-form]', pill);
    let joinOpen = false;
    let shown = false;
    let tucked = false;
    let menuOpen = false;
    let searchOpen = false;
    let leaving = false;
    // Visible once it has arrived, never over the open menu or open search, and unless tucked away on a touch screen
    // (an open card always stays).
    const showPill = () => {
      const on = shown && !leaving && !menuOpen && !searchOpen && (joinOpen || !tucked);
      pill.classList.toggle('pointer-events-none', !on);
      pill.classList.toggle('translate-y-4', !on);
      pill.classList.toggle('opacity-0', !on);
      pill.classList.toggle('translate-y-0', on);
      pill.classList.toggle('opacity-100', on);
    };
    // Arrives 3.5s after load: fades in and rises 16px, and takes no clicks until then.
    setTimeout(() => {
      shown = true;
      showPill();
    }, 3500);
    // Touch screens: it shows only over the top of the page (the hero), so it never sits on a tile's "+", a link or the
    // words being read further down, and it stays away while the footer, which has the same sign-up, is on screen.
    if (matchMedia('(hover: none)').matches) {
      let raf = 0;
      const check = () => {
        raf = 0;
        const past = scrollY > innerHeight * 0.5;
        const footer = $('footer')?.getBoundingClientRect();
        const next = past || Boolean(footer && footer.top < innerHeight);
        if (next !== tucked) {
          tucked = next;
          showPill();
        }
      };
      addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    }
    const setOpen = (open) => {
      if (open === joinOpen) return;
      joinOpen = open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close' : 'Join the list');
      if (joinLabel) joinLabel.textContent = open ? 'Close' : 'Join the list';
      card.setAttribute('aria-hidden', String(!open));
      card.classList.toggle('pointer-events-none', !open);
      card.classList.toggle('translate-y-2', !open);
      card.classList.toggle('scale-95', !open);
      card.classList.toggle('opacity-0', !open);
      card.classList.toggle('translate-y-0', open);
      card.classList.toggle('scale-100', open);
      card.classList.toggle('opacity-100', open);
      // Plus (a quarter turn on hover) <-> X.
      barA?.classList.toggle('group-hover:rotate-90', !open);
      barA?.classList.toggle('rotate-45', open);
      barB?.classList.toggle('rotate-90', !open);
      barB?.classList.toggle('group-hover:rotate-180', !open);
      barB?.classList.toggle('-rotate-45', open);
      // The form exists only while the card is open, so reopening always shows a fresh, empty form.
      if (open && formTpl) slot?.replaceChildren(formTpl.content.cloneNode(true));
      else slot?.replaceChildren();
      showPill();
    };
    toggle.addEventListener('click', () => setOpen(!joinOpen));
    $('[data-join-dismiss]', pill)?.addEventListener('click', () => {
      try {
        localStorage.setItem(JOIN_DISMISSED, '1');
      } catch {}
      setOpen(false);
      leaving = true;
      showPill();
      setTimeout(() => pill.remove(), 700);
    });
    addEventListener('vesari:menu', (e) => {
      menuOpen = Boolean(e.detail);
      if (menuOpen) setOpen(false);
      showPill();
    });
    // Search (setOpen in the header search block) says when it opens and closes.
    addEventListener('vesari:search', (e) => {
      searchOpen = Boolean(e.detail);
      if (searchOpen) setOpen(false);
      showPill();
    });
    // mousedown, not pointerdown: a touch-scroll outside the card must not close it.
    document.addEventListener('mousedown', (e) => joinOpen && !pill.contains(e.target) && setOpen(false));
    addEventListener('keydown', (e) => e.key === 'Escape' && joinOpen && setOpen(false));
  }

  /* ---------- welcome offer: email first, then the scratch card ---------- */
  const popup = $('[data-welcome-popup]');
  if (popup) {
    const CODE_KEY = 'vesari:welcome:code';
    // Signed up from the offer: never shown again in this browser.
    const JOINED_KEY = 'vesari:welcome:joined';
    // Bot challenge in progress: Shopify takes the shopper away and back, then the code step opens.
    const PENDING_KEY = 'vesari:welcome:pending';
    const WEEK = 7 * 24 * 60 * 60 * 1000;
    const EXIT_MS = 400;
    const card = $('[data-welcome-card]', popup);
    const joinPane = $('[data-welcome-pane="join"]', popup);
    const revealPane = $('[data-welcome-pane="reveal"]', popup);
    const form = $('form[data-newsletter]', popup);
    const emailField = $('[data-welcome-email]', popup);
    const hint = $('[data-welcome-hint]', popup);
    const after = $('[data-welcome-after]', popup);
    const code = popup.dataset.code || 'WELCOME10';
    const preview = new URLSearchParams(location.search).has('welcome');
    let scratched = false;
    let prevOverflow = '';
    let returnFocus = null;
    let startFoil = () => {};
    // When it shows (David, 2026-10-15): once per tab. Once it has opened in a tab it stays away there, across pages
    // and reloads, until the tab has gone unused for an hour; a new tab starts fresh (sessionStorage is per tab).
    // Signing up (never again) and taking the code (a quiet week) still apply in every tab.
    const VISIT_START = 'vesari:welcome:start';
    const VISIT_DONE = 'vesari:welcome:done';
    const ACTIVE_KEY = 'vesari:welcome:active';
    const IDLE_MS = 60 * 60 * 1000;
    const markVisitDone = () => {
      try {
        sessionStorage.setItem(VISIT_DONE, '1');
      } catch {}
    };
    const isOpen = () => popup.dataset.state === 'open';

    // Arrived from one of her emails (Shopify Email tags every link utm_medium=email): already on the list, so no
    // sign-up offer for the rest of that tab's visit (David, 2026-10-18).
    const FROM_EMAIL_KEY = 'vesari:welcome:from-email';
    try {
      if (new URLSearchParams(location.search).get('utm_medium') === 'email') sessionStorage.setItem(FROM_EMAIL_KEY, '1');
    } catch {}

    const shouldShow = () => {
      if (preview) return true;
      try {
        if (sessionStorage.getItem(FROM_EMAIL_KEY)) return false;
        if (localStorage.getItem(JOINED_KEY)) return false;
        const took = Number(localStorage.getItem(CODE_KEY)) || 0;
        if (Date.now() - took < WEEK) return false;
      } catch {}
      return true;
    };

    // Keep Tab inside the card while it is open.
    const trapTab = (e) => {
      const items = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"])', card).filter(
        (el) => el.offsetParent !== null && !el.closest('[inert]'),
      );
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === card)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    const setStep = (step) => {
      card.dataset.step = step;
      card.setAttribute('aria-labelledby', `wp-title-${step}`);
      joinPane?.toggleAttribute('data-active', step === 'join');
      joinPane?.toggleAttribute('inert', step !== 'join');
      revealPane?.toggleAttribute('data-active', step === 'reveal');
      revealPane?.toggleAttribute('inert', step !== 'reveal');
      if (step === 'reveal') startFoil();
    };

    const open = () => {
      markVisitDone();
      returnFocus = document.activeElement;
      popup.setAttribute('aria-hidden', 'false');
      popup.removeAttribute('inert');
      popup.dataset.state = 'open';
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      // Focus lands on the card itself, not the email field, so a phone keyboard does not jump up uninvited.
      setTimeout(() => !card.contains(document.activeElement) && card.focus({ preventScroll: true }), 80);
    };

    const close = () => {
      if (!isOpen()) return;
      popup.dataset.state = 'closing';
      // Scroll stays locked until the exit is over, then goes back to what it was before the offer opened.
      setTimeout(() => {
        popup.dataset.state = 'closed';
        popup.setAttribute('aria-hidden', 'true');
        popup.setAttribute('inert', '');
        document.body.style.overflow = prevOverflow;
        if (returnFocus instanceof HTMLElement) returnFocus.focus({ preventScroll: true });
      }, EXIT_MS);
      try {
        if (scratched) localStorage.setItem(CODE_KEY, String(Date.now()));
      } catch {}
    };

    $('[data-welcome-close]', popup)?.addEventListener('click', close);
    // As the site: clicking the backdrop does nothing; it closes only with the X (or Escape) or by signing up.
    // Shop now dismisses too (no preventDefault): close() writes both storage keys synchronously before the page leaves.
    $('[data-welcome-shop]', popup)?.addEventListener('click', close);
    addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trapTab(e);
    });
    emailField?.addEventListener('focus', () => card.setAttribute('data-typing', ''));
    $('[data-copy-code]', popup)?.addEventListener('click', async (e) => {
      const button = e.currentTarget;
      try {
        await navigator.clipboard.writeText(code);
        button.textContent = 'Copied';
        setTimeout(() => (button.textContent = 'Copy code'), 2000);
      } catch {}
    });

    // The shared newsletter handler saves the email; the offer only moves on to its code step.
    const joined = () => {
      try {
        localStorage.setItem(JOINED_KEY, String(Date.now()));
        sessionStorage.removeItem(PENDING_KEY);
      } catch {}
      setStep('reveal');
    };
    form?.addEventListener('newsletter:done', joined);
    form?.addEventListener('newsletter:challenge', () => {
      try {
        sessionStorage.setItem(PENDING_KEY, '1');
      } catch {}
    });

    // Back from Shopify's bot challenge with the email saved: open straight on the code.
    let returning = false;
    try {
      returning = sessionStorage.getItem(PENDING_KEY) === '1' && new URLSearchParams(location.search).get('customer_posted') === 'true';
      if (sessionStorage.getItem(PENDING_KEY) && !returning) sessionStorage.removeItem(PENDING_KEY);
    } catch {}
    if (returning) {
      joined();
      setTimeout(open, 600);
    } else {
      // One timer per tab visit: it starts when the tab first lands on the store (or comes back after an hour unused) and
      // keeps counting across page loads; once it has fired it never re-arms in that tab until the tab goes unused an hour.
      const delay = Number(popup.dataset.delay || 6) * 1000;
      const lastActive = () => Number(sessionStorage.getItem(ACTIVE_KEY)) || 0;
      const stamp = () => {
        try {
          sessionStorage.setItem(ACTIVE_KEY, String(Date.now()));
        } catch {}
      };
      // Shopify's cookie banner sits above everything and would cover the email field: wait until it is answered.
      const consentShowing = () => {
        const banner = document.getElementById('shopify-pc__banner');
        return !!banner && banner.getClientRects().length > 0 && getComputedStyle(banner).visibility !== 'hidden';
      };
      const fire = () => {
        if (consentShowing()) return setTimeout(fire, 500);
        // A ?welcome preview waits out the home intro instead of being skipped by it.
        if (preview && document.body.style.overflow === 'hidden') return setTimeout(fire, 500);
        // A tab that has gone out of view meanwhile keeps the offer for when the shopper is back.
        if (!preview && document.visibilityState === 'hidden') return setTimeout(fire, 1000);
        // Spent even when skipped, so a drawer that was open when it fired does not make it retry on the next page.
        markVisitDone();
        // A drawer (bag, size guide, menu) locks body scroll while open; do not stack the offer on top of it.
        if (document.body.style.overflow !== 'hidden') open();
      };
      let timer = 0;
      const arm = (wait) => {
        clearTimeout(timer);
        timer = setTimeout(fire, wait);
      };
      // Back in a tab that went unused for an hour: the offer comes back, as on a new visit.
      const comeBack = () => {
        if (isOpen() || !shouldShow()) return;
        try {
          sessionStorage.setItem(VISIT_START, String(Date.now()));
          sessionStorage.removeItem(VISIT_DONE);
        } catch {}
        arm(delay);
      };
      let visitStart = Date.now();
      let visitDone = false;
      try {
        const savedStart = Number(sessionStorage.getItem(VISIT_START)) || 0;
        const idle = !lastActive() || Date.now() - lastActive() > IDLE_MS;
        if (idle || !savedStart) {
          sessionStorage.setItem(VISIT_START, String(visitStart));
          sessionStorage.removeItem(VISIT_DONE);
        } else {
          visitStart = savedStart;
          visitDone = sessionStorage.getItem(VISIT_DONE) === '1';
        }
      } catch {}
      stamp();
      if ((preview || !visitDone) && shouldShow()) arm(preview ? 600 : Math.max(0, visitStart + delay - Date.now()));
      // "Used" = a tap, a key, a scroll, or the tab coming back into view; written at most every 15s.
      let lastTouch = Date.now();
      const touch = () => {
        const now = Date.now();
        if (now - lastTouch < 15000) return;
        lastTouch = now;
        let prev = 0;
        try {
          prev = lastActive();
        } catch {}
        stamp();
        if (prev && now - prev > IDLE_MS) comeBack();
      };
      ['pointerdown', 'keydown', 'scroll'].forEach((type) => addEventListener(type, touch, { passive: true }));
      document.addEventListener('visibilitychange', () => {
        lastTouch = 0;
        // Leaving the tab (switching away, or a page load) records it as used, unless it had already sat unused an hour:
        // that stays on record, so the next page or return brings the offer back.
        if (document.visibilityState === 'hidden') {
          let prev = 0;
          try {
            prev = lastActive();
          } catch {}
          if (!prev || Date.now() - prev <= IDLE_MS) stamp();
        } else touch();
      });
    }

    /* the foil itself */
    const wrap = $('[data-scratch]', popup);
    const canvas = $('[data-scratch-canvas]', popup);
    const skip = $('[data-scratch-skip]', popup);
    if (wrap && canvas) {
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      let drawing = false;
      let last = null;
      let checks = 0;
      let started = false;

      const paint = () => {
        const { width, height } = wrap.getBoundingClientRect();
        if (!width || !height) return;
        const dpr = Math.min(devicePixelRatio || 1, 2);
        canvas.width = Math.round(width * dpr);
        canvas.height = Math.round(height * dpr);
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

        const base = ctx.createLinearGradient(0, 0, width, height);
        base.addColorStop(0, '#cbc2b2');
        base.addColorStop(0.42, '#e7e0d3');
        base.addColorStop(0.58, '#f2ece1');
        base.addColorStop(1, '#c3b9a7');
        ctx.fillStyle = base;
        ctx.fillRect(0, 0, width, height);

        const sheen = ctx.createLinearGradient(-width * 0.2, height, width * 0.8, 0);
        sheen.addColorStop(0, 'rgba(255,255,255,0)');
        sheen.addColorStop(0.5, 'rgba(255,255,255,0.55)');
        sheen.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = sheen;
        ctx.fillRect(0, 0, width, height);

        ctx.globalAlpha = 0.05;
        for (let i = 0; i < (width * height) / 90; i++) {
          ctx.fillStyle = Math.random() > 0.5 ? '#ffffff' : '#8d8474';
          ctx.fillRect(Math.random() * width, Math.random() * height, 1, 1);
        }
        ctx.globalAlpha = 1;

        ctx.fillStyle = 'rgba(60,49,38,0.65)';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        // Canvas can't read CSS variables, so resolve the UI font stack from the page.
        const ui = getComputedStyle(document.documentElement).getPropertyValue('--font-ui').trim() || 'Helvetica, Arial, sans-serif';
        ctx.font = `500 11px ${ui}`;
        if ('letterSpacing' in ctx) ctx.letterSpacing = '0.18em';
        ctx.fillText('SCRATCH TO REVEAL', width / 2, height / 2);
      };

      const reveal = () => {
        if (scratched) return;
        scratched = true;
        canvas.classList.add('pointer-events-none', 'opacity-0', 'blur-[6px]');
        canvas.classList.remove('cursor-grab', 'active:cursor-grabbing');
        // The site repaints an intact foil as it dissolves, so the scratches do not show through the fade.
        if (!reduced) paint();
        skip?.classList.add('hidden');
        if (hint) hint.textContent = 'Here’s your code.';
        after?.setAttribute('data-shown', '');
        after?.removeAttribute('inert');
      };

      const cleared = () => {
        const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
        let clear = 0, seen = 0;
        for (let i = 3; i < data.length; i += 4 * 220) {
          seen++;
          if (data[i] < 24) clear++;
        }
        return seen > 0 && clear / seen > 0.55;
      };

      const scratch = (e) => {
        if (scratched) return;
        const r = canvas.getBoundingClientRect();
        const x = e.clientX - r.left;
        const y = e.clientY - r.top;
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = 38;
        const from = last || { x, y };
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(x, y);
        ctx.stroke();
        const g = ctx.createRadialGradient(x, y, 0, x, y, 26);
        g.addColorStop(0, 'rgba(0,0,0,1)');
        g.addColorStop(0.7, 'rgba(0,0,0,0.85)');
        g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(x, y, 26, 0, Math.PI * 2);
        ctx.fill();
        last = { x, y };
        if (++checks % 8 === 0 && cleared()) reveal();
      };

      // The foil is laid once the code step arrives (the site mounts its card then too).
      startFoil = () => {
        if (started) return;
        started = true;
        if (reduced) return reveal();
        paint();
        new ResizeObserver(() => !scratched && paint()).observe(wrap);
      };
      canvas.addEventListener('pointerdown', (e) => {
        canvas.setPointerCapture(e.pointerId);
        drawing = true;
        last = null;
        scratch(e);
      });
      canvas.addEventListener('pointermove', (e) => drawing && scratch(e));
      canvas.addEventListener('pointerup', () => {
        drawing = false;
        last = null;
        if (!scratched && cleared()) reveal();
      });
      canvas.addEventListener('pointerleave', () => {
        drawing = false;
        last = null;
      });
      skip?.addEventListener('click', reveal);
      // Joined on an earlier page load (back from the challenge): the code step is already showing.
      if (card.dataset.step === 'reveal') startFoil();
    }
  }

  /* ---------- contact form: the site's checks, run before Shopify's captcha listener, then "Sending" ---------- */
  if ($('form[data-contact-form]')) {
    const CONTACT_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const contactButton = (form) => form.querySelector('button[type="submit"]');
    $$('form[data-contact-form]').forEach((form) => {
      const button = contactButton(form);
      if (button) button.dataset.label = button.textContent;
    });
    // Window + capture phase: an invalid form never reaches Shopify's document-level captcha listener.
    addEventListener('submit', (e) => {
      const form = e.target instanceof Element ? e.target.closest('form[data-contact-form]') : null;
      if (!form) return;
      const button = contactButton(form);
      const email = form.querySelector('[name="contact[email]"]');
      const message = form.querySelector('[name="contact[body]"]');
      if (!button || !email || !message) return;
      const stop = () => {
        e.preventDefault();
        e.stopImmediatePropagation();
      };
      // Already sending (the disabled button blocks clicks and Enter): let a re-dispatch by Shopify's captcha through.
      if (button.disabled) return;
      // Like the site's setMessage(null): the previous message goes before the form is checked again.
      form.querySelectorAll('[role="alert"]').forEach((n) => n.remove());
      email.removeAttribute('aria-invalid');
      if (!CONTACT_EMAIL.test(email.value.trim())) {
        stop();
        const alert = document.createElement('span');
        alert.setAttribute('role', 'alert');
        alert.className = 'mt-2 block text-[13px] text-ink';
        alert.textContent = email.dataset.invalid || 'Enter a valid email address.';
        email.setAttribute('aria-invalid', 'true');
        email.after(alert);
        return;
      }
      if (message.value.trim().length < 5) {
        stop();
        const alert = document.createElement('p');
        alert.setAttribute('role', 'alert');
        alert.className = 'text-[13px] text-ink';
        alert.textContent = message.dataset.invalid || 'Tell us a little more so we can help.';
        button.before(alert);
        return;
      }
      // The site sends the trimmed address.
      email.value = email.value.trim();
      button.textContent = button.dataset.sending || 'Sending';
      button.disabled = true;
    }, true);
    // A back navigation restores the page from cache: give the button back.
    addEventListener('pageshow', () => {
      $$('form[data-contact-form]').forEach((form) => {
        const button = contactButton(form);
        if (!button) return;
        button.disabled = false;
        if (button.dataset.label) button.textContent = button.dataset.label;
      });
    });
  }

  /* ---------- product reviews: fit scale, show all, write a review ---------- */
  const reviewsRoot = $('#reviews');
  if (reviewsRoot) {
    // The site's regexes (src/lib/reviews.ts): Judge.me has no fit question on this store, so fit
    // is read from what reviewers wrote. -1 runs small, 0 true to size, 1 runs large.
    const SMALL = /\b(runs?|fits?|is|a) small\b|small fit|\bsized? up\b|\bgo up a size\b|too (tight|small)/i;
    const LARGE = /\b(runs?|fits?|is|a) (large|big)\b|large fit|\bsized? down\b|\bgo down a size\b|too (big|loose|large)/i;
    const TRUE = /true to size|\bfits? perfectly\b|\bperfect fit\b|\b(great|excellent|good|flawless) fit\b|\bfit perfectly\b|\bfits? (great|well)\b/i;
    const fit = $('[data-fit]', reviewsRoot);
    if (fit) {
      const votes = $$('[data-review]', reviewsRoot)
        .map((li) => `${$('[data-review-title]', li)?.textContent || ''} ${$('[data-review-body]', li)?.textContent || ''}`)
        .map((t) => (SMALL.test(t) ? -1 : LARGE.test(t) ? 1 : TRUE.test(t) ? 0 : null))
        .filter((v) => v !== null);
      if (votes.length) {
        const score = votes.reduce((a, b) => a + b, 0) / votes.length;
        const dot = $('[data-fit-dot]', fit);
        dot.style.left = `${((score + 1) / 2) * 100}%`;
        dot.setAttribute('aria-label', `Fit: ${score < -0.33 ? 'runs small' : score > 0.33 ? 'runs large' : 'true to size'}`);
        $('[data-fit-note]', fit).textContent = `From ${votes.length} ${votes.length === 1 ? 'review' : 'reviews'} that mention fit`;
        fit.hidden = false;
      }
    }

    $('[data-reviews-all]', reviewsRoot)?.addEventListener('click', (e) => {
      $$('[data-review].hidden', reviewsRoot).forEach((li) => li.classList.remove('hidden'));
      e.currentTarget.remove();
    });

    // The site's button leaves for the store page that hosts Judge.me's form; on the store that page
    // is this one, so show Judge.me's widget and open its form here.
    const reviewApp = $('[data-review-app]');
    const openReviewForm = () => {
      if (!reviewApp) return false;
      reviewApp.hidden = false;
      const write = [...reviewApp.querySelectorAll('a, button')].find((el) => /write a review/i.test(el.textContent));
      write?.click();
      reviewApp.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      return true;
    };
    $('[data-write-review]', reviewsRoot)?.addEventListener('click', (e) => {
      if (openReviewForm()) e.preventDefault();
    });
    if (location.hash === '#judgeme_product_reviews') addEventListener('load', openReviewForm);
  }

  /* ---------- Our Standard: the composition ring and the light on the cotton (the site's src/lib/standard.ts) ---------- */
  const initComposition = (root) => {
    if (root.dataset.compositionReady) return;
    root.dataset.compositionReady = '1';
    const options = $$('[data-fibre-key]', root);
    const arcs = $$('.composition-arc', root);
    const counts = $$('[data-count]', root);
    const photo = root.closest('section')?.querySelector('[data-fibre-visual]') || null;

    // What the ring shows: the fibre under the mouse, else the opening demo, else the one selected.
    let hovered = null;
    let demoKey = null;
    let pinned = 'cotton';
    // Touch has no hover, so a tap previews its fibre on the photo for a moment, as hovering does with a mouse.
    let tapped = null;
    let tapTimer = 0;
    let pointer = 'mouse';
    let current = root.dataset.active || 'cotton';
    const apply = () => {
      const key = hovered ?? demoKey ?? pinned;
      options.forEach((o) => o.setAttribute('aria-pressed', String(o.dataset.fibreKey === pinned)));
      // The photo eases in while a fibre is previewed (hover or the opening demo).
      if (photo) {
        const preview = hovered ?? demoKey ?? tapped;
        if (preview) photo.dataset.view = preview;
        else delete photo.dataset.view;
      }
      if (key === current) return;
      current = key;
      root.dataset.active = key;
    };

    // Once, after the ring draws: show the spandex, then settle back on the cotton.
    let demo = [];
    const stopDemo = () => {
      demo.forEach(clearTimeout);
      demo = [];
      if (demoKey) {
        demoKey = null;
        apply();
      }
    };
    const runDemo = () => {
      if (reduced) return;
      demo = [
        setTimeout(() => ((demoKey = 'spandex'), apply()), 1200),
        setTimeout(() => ((demoKey = null), apply()), 3600),
      ];
    };

    // The ring draws in and the figures count up the first time it comes into view.
    const draw = () => {
      root.classList.add('is-drawn');
      if (!reduced) {
        counts.forEach((c) => {
          const to = Number(c.dataset.count);
          const start = performance.now();
          const step = (now) => {
            const p = Math.min(1, (now - start) / 1400);
            c.textContent = String(Math.round(to * (1 - Math.pow(1 - p, 4))));
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        });
      }
      setTimeout(() => {
        root.classList.add('is-ready');
        if (!hovered && pinned === 'cotton') runDemo();
      }, reduced ? 0 : 1700);
    };
    if (reduced || !('IntersectionObserver' in window)) draw();
    else {
      counts.forEach((c) => (c.textContent = '0'));
      const io = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            io.disconnect();
            draw();
          }
        },
        { threshold: 0.4 },
      );
      io.observe(root);
    }

    // Hovering a fibre (its row or its arc) previews it; a click or tap selects it.
    const bind = (el, key) => {
      el.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        stopDemo();
        hovered = key;
        apply();
      });
      el.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        hovered = null;
        apply();
      });
      el.addEventListener('click', () => {
        stopDemo();
        pinned = key;
        if (pointer !== 'mouse') {
          tapped = key;
          clearTimeout(tapTimer);
          tapTimer = setTimeout(() => {
            tapped = null;
            apply();
          }, 1800);
        }
        apply();
      });
    };
    root.addEventListener('pointerdown', (e) => (pointer = e.pointerType));
    options.forEach((o) => bind(o, o.dataset.fibreKey || 'cotton'));
    arcs.forEach((a) => bind(a, a.dataset.fibre || 'cotton'));
  };

  /* A soft light that trails the cursor across the photo. Touch screens have no cursor, so there it drifts over the
     fabric on its own while the photo is on screen. */
  const initSheen = (el) => {
    if (el.dataset.sheenReady || reduced) return;
    el.dataset.sheenReady = '1';
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches) {
      // Touch: the light wanders slowly over the fabric (two slow sine paths) while the photo is in view.
      let raf = 0;
      let start = 0;
      const tick = (now) => {
        if (!start) start = now;
        const t = (now - start) / 1000;
        el.style.setProperty('--sx', `${(50 + 32 * Math.sin((t / 9) * 2 * Math.PI)).toFixed(2)}%`);
        el.style.setProperty('--sy', `${(42 + 24 * Math.sin((t / 6.5) * 2 * Math.PI + 1.1)).toFixed(2)}%`);
        raf = requestAnimationFrame(tick);
      };
      new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          el.dataset.drift = '';
          if (!raf) raf = requestAnimationFrame(tick);
        } else {
          delete el.dataset.drift;
          cancelAnimationFrame(raf);
          raf = 0;
        }
      }, { threshold: 0.25 }).observe(el);
      return;
    }
    let tx = 50;
    let ty = 40;
    let x = 50;
    let y = 40;
    let raf = 0;
    const tick = () => {
      x += (tx - x) * 0.12;
      y += (ty - y) * 0.12;
      el.style.setProperty('--sx', `${x.toFixed(2)}%`);
      el.style.setProperty('--sy', `${y.toFixed(2)}%`);
      raf = Math.abs(tx - x) + Math.abs(ty - y) > 0.1 ? requestAnimationFrame(tick) : 0;
    };
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width) * 100;
      ty = ((e.clientY - r.top) / r.height) * 100;
      if (!raf) raf = requestAnimationFrame(tick);
    });
  };

  /* ---------- Collection filter chips: Tops / Tanks / Jackets (the site's src/lib/collection-filter.ts) ---------- */
  const initCollectionFilter = (root) => {
    if (root.dataset.filterReady) return;
    root.dataset.filterReady = '1';
    const chips = $$('[data-filter-key]', root);
    const items = $$('[data-group]', root);
    const count = $('[data-filter-count]', root);
    const keys = chips.map((c) => c.dataset.filterKey || '');
    const show = (wanted, push) => {
      const key = keys.includes(wanted) ? wanted : 'all';
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.filterKey === key)));
      let n = 0;
      items.forEach((li) => {
        const on = key === 'all' || li.dataset.group === key;
        li.hidden = !on;
        if (on) n++;
      });
      if (count) count.textContent = `${n} ${n === 1 ? 'piece' : 'pieces'}`;
      if (push) history.replaceState(history.state, '', key === 'all' ? location.pathname + location.search : `#${key}`);
    };
    const fromHash = () => show(decodeURIComponent(location.hash.slice(1)), false);
    chips.forEach((c) => c.addEventListener('click', () => show(c.dataset.filterKey || 'all', true)));
    addEventListener('hashchange', fromHash);
    fromHash();
  };

  $$('[data-composition]').forEach(initComposition);
  $$('[data-sheen]').forEach(initSheen);
  $$('[data-collection-filter]').forEach(initCollectionFilter);
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-composition]', e.target).forEach(initComposition);
    $$('[data-sheen]', e.target).forEach(initSheen);
    $$('[data-collection-filter]', e.target).forEach(initCollectionFilter);
  });
})();
